/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../merchants/api';
import '../common/countries';
import '../privacyvault/annotations';
import '../common/currency_codes';
import './business_hours';
import '../common/location';
import '../employees/employees';
import '../common/two_factor';
import './gateway';
import './common';
import '../common/currency';
import '../common/time';
import '../common/merchant_type';
import '../common/gateways';
import '../bank-accounts/bank_accounts';
import '../payments/attributes/model/model';
import '../common/address';
import './mds_audit_log';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "roster": {
        "nested": {
          "mds": {
            "nested": {
              "Merchant": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "name": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 6,
                    "rule": "optional"
                  },
                  "addresses": {
                    "type": ".squareup.roster.mds.AddressEntry",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "locale": {
                    "type": ".squareup.merchants.api.UserLocale",
                    "id": 8,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 23,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.roster.mds.StatusScope.Status",
                    "id": 10,
                    "rule": "optional"
                  },
                  "createdTs": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedTs": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "ucf": {
                    "type": ".squareup.roster.mds.UnderwritingComplianceFlags",
                    "id": 15,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "int64",
                    "id": 20,
                    "rule": "optional"
                  },
                  "mainUnitToken": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "mainUnit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 22,
                    "rule": "optional"
                  },
                  "oldestUnitToken": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "reservedMerchantToken": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "platformAccountToken": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "platformHidden": {
                    "type": "bool",
                    "id": 27,
                    "rule": "optional"
                  },
                  "capabilities": {
                    "type": ".squareup.roster.mds.MerchantCapabilities",
                    "id": 28,
                    "rule": "optional"
                  },
                  "businessUnit": {
                    "type": ".squareup.roster.mds.BusinessUnit",
                    "id": 29,
                    "rule": "optional"
                  },
                  "legalEntityToken": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "mainUnitTokenOverride": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "vaultedData": {
                    "type": ".squareup.privacyvault.VaultedData",
                    "id": 999,
                    "rule": "optional"
                  }
                }
              },
              "Unit": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 7,
                    "rule": "optional"
                  },
                  "frozen": {
                    "type": "bool",
                    "id": 27,
                    "rule": "optional"
                  },
                  "name": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 8,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 10,
                    "rule": "optional"
                  },
                  "addresses": {
                    "type": ".squareup.roster.mds.AddressEntry",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "locale": {
                    "type": ".squareup.merchants.api.UserLocale",
                    "id": 12,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "mcc": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.roster.mds.ImageEntry",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "status": {
                    "type": ".squareup.roster.mds.StatusScope.Status",
                    "id": 15,
                    "rule": "optional"
                  },
                  "contactMethods": {
                    "type": ".squareup.roster.mds.ContactMethod",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "createdTs": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional"
                  },
                  "updatedTs": {
                    "type": "int64",
                    "id": 18,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "ucf": {
                    "type": ".squareup.roster.mds.UnderwritingComplianceFlags",
                    "id": 20,
                    "rule": "optional"
                  },
                  "unitId": {
                    "type": "int64",
                    "id": 26,
                    "rule": "optional"
                  },
                  "hasNoAutomaticPointOfSaleImage": {
                    "type": "bool",
                    "id": 28,
                    "rule": "optional"
                  },
                  "businessIds": {
                    "type": ".squareup.roster.mds.BusinessIds",
                    "id": 29,
                    "rule": "optional"
                  },
                  "capabilities": {
                    "type": ".squareup.roster.mds.UnitCapabilities",
                    "id": 30,
                    "rule": "optional"
                  },
                  "businessHours": {
                    "type": ".squareup.roster.business_hours.BusinessHours",
                    "id": 31,
                    "rule": "optional"
                  },
                  "specialHours": {
                    "type": ".squareup.roster.business_hours.SpecialBusinessHours",
                    "id": 32,
                    "rule": "optional"
                  },
                  "businessUnit": {
                    "type": ".squareup.roster.mds.BusinessUnit",
                    "id": 33,
                    "rule": "optional"
                  },
                  "legalEntityToken": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "vaultedData": {
                    "type": ".squareup.privacyvault.VaultedData",
                    "id": 999,
                    "rule": "optional"
                  }
                }
              },
              "BusinessUnit": {
                "values": {
                  "DEFAULT_BUSINESS_UNIT_DO_NOT_USE": 0,
                  "SQUARE": 1,
                  "CASH_APP": 2,
                  "AFTERPAY": 3
                }
              },
              "MerchantProfile": {
                "fields": {
                  "email": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "mobileMerchant": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "UnitInfo": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.roster.mds.StatusScope.Status",
                    "id": 15,
                    "rule": "optional"
                  },
                  "merchantProfile": {
                    "type": ".squareup.roster.mds.MerchantProfile",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Employment": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 22,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "roleAssignments": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "firstName": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 11,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 12,
                    "rule": "optional"
                  },
                  "merchantSuppliedContactMethods": {
                    "type": ".squareup.roster.mds.ContactMethod",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "createdTs": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "updatedTs": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "employeeNumber": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "isAuthorizedUser": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "accessBlockers": {
                    "type": ".squareup.employees.AccessBlocker",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "phoneNumber": {
                    "type": ".squareup.roster.mds.ContactMethod",
                    "id": 20,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 25,
                    "rule": "optional"
                  },
                  "vaultedData": {
                    "type": ".squareup.privacyvault.VaultedData",
                    "id": 999,
                    "rule": "optional"
                  }
                }
              },
              "EmployeeRoleAssignment": {
                "fields": {
                  "roleTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "roles": {
                    "type": ".squareup.roster.mds.EmployeeRole",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "expandedAuthorizedMerchants": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment.MerchantList",
                    "id": 8,
                    "rule": "optional"
                  },
                  "expandedAuthorizedUnits": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment.UnitList",
                    "id": 9,
                    "rule": "optional"
                  },
                  "overridePermissions": {
                    "type": ".squareup.roster.mds.EmployeePermissions",
                    "id": 7,
                    "rule": "optional"
                  },
                  "addOnlyMerchants": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment.MerchantList",
                    "id": 3
                  },
                  "addOnlyUnits": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment.UnitList",
                    "id": 5
                  },
                  "allExceptUnits": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment.UnitList",
                    "id": 6
                  }
                },
                "nested": {
                  "MerchantList": {
                    "fields": {
                      "merchantTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "merchants": {
                        "type": ".squareup.roster.mds.Merchant",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UnitList": {
                    "fields": {
                      "unitTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "units": {
                        "type": ".squareup.roster.mds.Unit",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "authorized_merchants": {
                    "oneof": ["addOnlyMerchants"]
                  },
                  "authorized_units": {
                    "oneof": ["addOnlyUnits", "allExceptUnits"]
                  }
                }
              },
              "EmploymentLite": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isAdmin": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "hasFreeRole": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "hasPasscode": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "hasPerson": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "EmployeeRole": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": ".squareup.roster.mds.EmployeePermissions",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isAdmin": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "roleType": {
                    "type": ".squareup.roster.mds.EmployeeRole.RoleType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "managedRoleTokens": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "version": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "canEmployeesAccessAppointments": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isFreeRole": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "passcode": {
                    "type": ".squareup.roster.mds.EmployeePasscode",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedTs": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "createdTs": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RoleType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CUSTOM": 1,
                      "ACCOUNT_OWNER": 2,
                      "MERCHANT_ADMINISTRATOR": 3,
                      "MOBILE_STAFF": 4,
                      "UNIT_ADMINISTRATOR": 5,
                      "GUEST": 6,
                      "EXTRA": 7
                    }
                  }
                }
              },
              "EmployeePermissions": {
                "fields": {
                  "addOnly": {
                    "type": "bytes",
                    "id": 1
                  },
                  "allExcept": {
                    "type": "bytes",
                    "id": 2
                  }
                },
                "nested": {
                  "type": {
                    "oneof": ["addOnly", "allExcept"]
                  }
                }
              },
              "SecuritySettings": {
                "fields": {
                  "requiresTwoFactor": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "twoFactorState": {
                    "type": ".squareup.common.twofactor.TwoFactorState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "legacy2faSupported": {
                    "type": ".squareup.common.twofactor.LegacyTwoFactorSupport",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MerchantPaymentData": {
                "fields": {
                  "gatewayMerchantData": {
                    "type": ".squareup.roster.gateway.GatewayMerchantData",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paymentFlowPreferences": {
                    "type": ".squareup.roster.mds.PaymentFlowPreferences",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enforcesSinglePaymentConfiguration": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "MerchantPosData": {
                "fields": {
                  "tippingPreference": {
                    "type": ".squareup.roster.common.TippingPreference",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerchantMultipassData": {
                "fields": {
                  "securitySettings": {
                    "type": ".squareup.roster.mds.SecuritySettings",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerchantLegacyData": {
                "fields": {
                  "userData": {
                    "type": ".squareup.roster.mds.UserLegacyData",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitOnlineStoreData": {
                    "type": ".squareup.roster.mds.UnitOnlineStoreData",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isLegacySingleUnit": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "MerchantBillingData": {
                "fields": {
                  "subscriptionFeatureStatus": {
                    "type": ".squareup.roster.common.SubscriptionFeatureStatus",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MerchantGiftCardsData": {
                "fields": {
                  "useGiftCardsV2Override": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exportGiftCardPans": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MerchantEmSubscriptionData": {
                "fields": {
                  "subscribedUnitTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "onLocationBasedPricing": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fetchFromEmSubscriptions": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MerchantAppointmentsData": {
                "fields": {
                  "appointmentsJoinedAt": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerchantMarketingData": {
                "fields": {
                  "smsInvitationEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "emailReceiptConsentIncentive": {
                    "type": ".squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive",
                    "id": 2,
                    "rule": "optional"
                  },
                  "smsNumberVerified": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EmailReceiptConsentIncentive": {
                    "fields": {
                      "itemNames": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "categoryNames": {
                        "type": "string",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "discountScope": {
                        "type": ".squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive.DiscountScope",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": "WHOLE_ORDER"
                        }
                      },
                      "emailReceiptOptinCouponAmountOff": {
                        "type": ".squareup.common.Money",
                        "id": 1
                      },
                      "emailReceiptOptinCouponPercentageOff": {
                        "type": ".squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive.PercentageOff",
                        "id": 2
                      }
                    },
                    "nested": {
                      "DiscountScope": {
                        "values": {
                          "WHOLE_ORDER": 1,
                          "CATEGORY": 2,
                          "ITEM": 3
                        }
                      },
                      "PercentageOff": {
                        "fields": {
                          "percentageOff": {
                            "type": "uint32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "emailReceiptOptinCouponPercentageOffMaxDiscount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "discount": {
                        "oneof": ["emailReceiptOptinCouponAmountOff", "emailReceiptOptinCouponPercentageOff"]
                      }
                    }
                  }
                }
              },
              "Hours": {
                "fields": {
                  "dayOfWeek": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "openIntervals": {
                    "type": ".squareup.roster.mds.Hours.Interval",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Interval": {
                    "fields": {
                      "start": {
                        "type": ".squareup.common.time.LocalTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "durationMinutes": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UnitHoursData": {
                "fields": {
                  "normalHours": {
                    "type": ".squareup.roster.mds.Hours",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UnitPaymentData": {
                "fields": {
                  "transactionFundName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantType": {
                    "type": ".squareup.common.MerchantType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "gatewayMerchantData": {
                    "type": ".squareup.roster.gateway.GatewayMerchantData",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "gatewayHints": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "transactionMinCents": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "lowRisk": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "attributes": {
                    "type": ".squareup.roster.mds.UnitPaymentData.AttributeTimeSeries",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "protoSource": {
                    "type": ".squareup.roster.mds.UnitPaymentData.Source",
                    "id": 18,
                    "rule": "optional"
                  },
                  "receiptMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkedBankAccountToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "readerState": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "linkedBankAccountType": {
                    "type": ".squareup.bank_accounts.BankAccountType",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cpInterchangeCents": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "cnpInterchangeCents": {
                    "type": "int32",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cpDiscountBasisPoints": {
                    "type": "int32",
                    "id": 12,
                    "rule": "optional"
                  },
                  "cnpDiscountBasisPoints": {
                    "type": "int32",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TimedValue": {
                    "fields": {
                      "activeAtMillis": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "expireAtMillis": {
                        "type": "int64",
                        "id": 2,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "AttributeTimeSeries": {
                    "fields": {
                      "type": {
                        "type": ".squareup.payments.attributes.model.AttributeTypes.AttributeType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "values": {
                        "type": ".squareup.roster.mds.UnitPaymentData.TimedValue",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Source": {
                    "values": {
                      "ROSTER": 1,
                      "PAYATTR": 2
                    }
                  }
                }
              },
              "UnitPosData": {
                "fields": {
                  "tippingPreference": {
                    "type": ".squareup.roster.common.TippingPreference",
                    "id": 1,
                    "rule": "optional"
                  },
                  "uk": {
                    "type": ".squareup.roster.mds.UnitPosData.UKPosData",
                    "id": 2
                  },
                  "ca": {
                    "type": ".squareup.roster.mds.UnitPosData.CAPosData",
                    "id": 3
                  },
                  "au": {
                    "type": ".squareup.roster.mds.UnitPosData.AUPosData",
                    "id": 4
                  },
                  "fr": {
                    "type": ".squareup.roster.mds.UnitPosData.FRPosData",
                    "id": 5
                  }
                },
                "nested": {
                  "UKPosData": {
                    "fields": {
                      "vatNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "vatCustomerClass": {
                        "type": ".squareup.roster.mds.UnitPosData.UKPosData.VatCustomerClass",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "VatCustomerClass": {
                        "values": {
                          "b2b_null": 1,
                          "b2b": 2
                        }
                      }
                    }
                  },
                  "CAPosData": {
                    "fields": {
                      "gstHstNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "qstNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AUPosData": {
                    "fields": {
                      "abn": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "acn": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "FRPosData": {
                    "fields": {
                      "siren": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "vta": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tva": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "nic": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "naf": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rcs": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "companyFormation": {
                        "type": ".squareup.roster.mds.UnitPosData.FRPosData.CompanyFormation",
                        "id": 7,
                        "rule": "optional"
                      },
                      "shareCapital": {
                        "type": "int64",
                        "id": 8,
                        "rule": "optional"
                      },
                      "siret": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CompanyFormation": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "SARL": 1,
                          "SA": 2,
                          "SAS": 3,
                          "SNC": 4,
                          "SCS": 5,
                          "SEL": 6,
                          "EURL": 7
                        }
                      }
                    }
                  },
                  "country_specific_pos_data": {
                    "oneof": ["uk", "ca", "au", "fr"]
                  }
                }
              },
              "UnitOnlineStoreData": {
                "fields": {
                  "pickupEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shippingEnabled": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "profilePublished": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "slug": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "marketUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "curated": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "notBeShownInDirectory": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "onlyBeSeenByBetaCustomers": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "UnitBrandData": {
                "fields": {
                  "description": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "facebookUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "twitter": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardColor": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "instagram": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "UnitSecurityData": {
                "fields": {
                  "bypassFlipperStagingWhitelist": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UnitReceiptsData": {
                "fields": {
                  "useReceiptsFeedback": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "notSendAutomaticReceipts": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "returnPolicy": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "receiptShowItemDescription": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "receiptShowLocation": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "receiptShowReferral": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "receiptMessage": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "receiptShowTotalSavingsRow": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "receiptShowItemizedCartLevelDiscounts": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "UnitLocationData": {
                "fields": {
                  "mobileBusiness": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "location": {
                    "type": ".squareup.common.location.Coordinates",
                    "id": 2,
                    "rule": "optional"
                  },
                  "geocodingFailedTs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UnitLegacyData": {
                "fields": {
                  "userData": {
                    "type": ".squareup.roster.mds.UserLegacyData",
                    "id": 1,
                    "rule": "optional"
                  },
                  "starbucksStorefrontName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "starbucksExternalId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "starbucksPhoneNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "starbucksFilterable": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "UserLegacyData": {
                "fields": {
                  "legacyUserId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "userName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": ".squareup.common.location.Phone",
                    "id": 4,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "string",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "userPermissionIds": {
                    "type": "int32",
                    "id": 14,
                    "rule": "repeated"
                  }
                }
              },
              "UnitBillingData": {
                "fields": {
                  "subscriptionFeatureStatus": {
                    "type": ".squareup.roster.common.SubscriptionFeatureStatus",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UnitActivationData": {
                "fields": {
                  "businessCategory": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessSubCategory": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "personalFirstName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "personalLastName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "underwritingRequestTokens": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "UnitPosServiceSettingsData": {
                "fields": {
                  "closeOfDayReports": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.CloseOfDayReports",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeShiftReports": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.EmployeeShiftReports",
                    "id": 2,
                    "rule": "optional"
                  },
                  "menuBehaviorSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.MenuBehaviorSettings",
                    "id": 3,
                    "rule": "optional"
                  },
                  "printedReceiptSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.ReceiptSettings",
                    "id": 4,
                    "rule": "optional"
                  },
                  "autoGratuitySettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.AutoGratuitySettings",
                    "id": 5,
                    "rule": "optional"
                  },
                  "salesAttributionSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.SalesAttributionSettings",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reopenSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.ReopenSettings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "courseSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.CourseSettings",
                    "id": 8,
                    "rule": "optional"
                  },
                  "preAuthSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.PreAuthSettings",
                    "id": 9,
                    "rule": "optional"
                  },
                  "reservationSettings": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData.ReservationSettings",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CloseOfDayReports": {
                    "fields": {
                      "openTicketsMustBeClosed": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "tipsMustBeSettledManually": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "cashDrawersMustBeClosed": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "clockedInEmployeesMustBeClockedOut": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showCategorySales": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showIndividualItemSales": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showDiscountsSections": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showCategoryRollupSales": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      }
                    }
                  },
                  "EmployeeShiftReports": {
                    "fields": {
                      "openTicketsMustBeClosed": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "tipsMustBeSettledManually": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "autoGratuityPaidOutAsCashTips": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showCategorySales": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showIndividualItemSales": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showDiscountsSections": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showCategoryRollupSales": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "showCashOwed": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      }
                    }
                  },
                  "MenuBehaviorSettings": {
                    "fields": {
                      "behaviorAfterAddingItem": {
                        "type": ".squareup.roster.mds.UnitPosServiceSettingsData.MenuBehaviorSettings.BehaviorAfterAddingItem",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "RETURN_TO_HOME_SCREEN"
                        }
                      }
                    },
                    "nested": {
                      "BehaviorAfterAddingItem": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "RETURN_TO_HOME_SCREEN": 1,
                          "REMAIN_ON_CURRENT_SCREEN": 2
                        }
                      }
                    }
                  },
                  "ReceiptSettings": {
                    "fields": {
                      "showFreeModifiers": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "combineLikeItems": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "AutoGratuitySettings": {
                    "fields": {
                      "autoGratuityEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SalesAttributionSettings": {
                    "fields": {
                      "ticketOwnerPreference": {
                        "type": ".squareup.roster.mds.UnitPosServiceSettingsData.SalesAttributionSettings.TicketOwnerPreference",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "CREATOR_EMPLOYEE"
                        }
                      }
                    },
                    "nested": {
                      "TicketOwnerPreference": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "CREATOR_EMPLOYEE": 1,
                          "CLOSING_EMPLOYEE": 2
                        }
                      }
                    }
                  },
                  "ReopenSettings": {
                    "fields": {
                      "canReopenChecks": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "CourseSettings": {
                    "fields": {
                      "courseNames": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "printingCoursingTrueHoldEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "PreAuthSettings": {
                    "fields": {
                      "isPreAuthEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "preAuthMin": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReservationSettings": {
                    "fields": {
                      "firstTableTouch": {
                        "type": ".squareup.roster.mds.UnitPosServiceSettingsData.ReservationSettings.FirstTableTouch",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "FIRST_TABLE_TOUCH_UNUSED"
                        }
                      }
                    },
                    "nested": {
                      "FirstTableTouch": {
                        "values": {
                          "NOT_SET": 0,
                          "ENABLED": 1,
                          "DISABLED": 2,
                          "FIRST_TABLE_TOUCH_UNUSED": 3,
                          "FIRST_TABLE_TOUCH_ON": 4,
                          "FIRST_TABLE_TOUCH_OFF": 5
                        }
                      }
                    }
                  }
                }
              },
              "LegacyRolloutData": {
                "fields": {
                  "linkCardOnFile": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "linkCardOnFileAu": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "linkCardOnFileCa": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkCardOnFileJp": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "linkCardOnFileUk": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "seeDiscountAndCompName": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "enableReceiveRevampedSalesSummaryEmail": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ImagePurposeScope": {
                "fields": {},
                "nested": {
                  "ImagePurpose": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PROFILE": 1,
                      "RECEIPT": 2,
                      "POINT_OF_SALE": 3,
                      "POINT_OF_SALE_ADDITIONAL": 4,
                      "POINT_OF_SALE_TERMINAL": 6,
                      "PROFILE_BANNER": 5
                    }
                  }
                }
              },
              "ImageEntry": {
                "fields": {
                  "imagePurposes": {
                    "type": ".squareup.roster.mds.ImagePurposeScope.ImagePurpose",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "contentDigest": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "contentType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fileName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "width": {
                    "type": "uint32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "height": {
                    "type": "uint32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "centerX": {
                    "type": "uint32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "centerY": {
                    "type": "uint32",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "UnitBankingData": {
                "fields": {
                  "isManualSeller": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EmploymentMultipassData": {
                "fields": {
                  "passcodeFideliusToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "passcodeHashedForUniqueness": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "passcodeHashedForClient": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "passcodeSalt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "passcodeIterations": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "EmployeePasscode": {
                "fields": {
                  "fideliusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "hashedPasscode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "salt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "uniquenessHash": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "iterations": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdTs": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "EmploymentEmployeesData": {
                "fields": {
                  "passcode": {
                    "type": ".squareup.roster.mds.EmployeePasscode",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EmploymentLegacyData": {
                "fields": {
                  "isOwner": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authorizedUnitTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "mobileStaffDelegateOfUnitToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "mobileStaffUserData": {
                    "type": ".squareup.roster.mds.UserLegacyData",
                    "id": 10,
                    "rule": "optional"
                  },
                  "syntheticEmploymentType": {
                    "type": ".squareup.roster.mds.EmploymentLegacyData.SyntheticEmploymentType",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SyntheticEmploymentType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LEGACY_SINGLE_UNIT_OWNER": 1,
                      "UNIT_LOGIN": 2,
                      "MOBILE_STAFF": 3
                    }
                  }
                }
              },
              "EmploymentPayrollData": {
                "fields": {
                  "hourlyWageRate": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "annualWageRate": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "wageType": {
                    "type": ".squareup.roster.mds.EmploymentPayrollData.WageType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "hoursWorkedPerWeek": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "flsaExempt": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "WageType": {
                    "values": {
                      "HOURLY": 0,
                      "ANNUAL": 1
                    }
                  }
                }
              },
              "EmploymentInternalData": {
                "fields": {
                  "employmentType": {
                    "type": ".squareup.roster.mds.EmploymentInternalData.EmploymentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "roleAssignmentInfo": {
                    "type": ".squareup.roster.mds.EmploymentInternalData.RoleAssignmentInfo",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "annualWageRate": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "hourlyWageRate": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "selfEmployed": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EmploymentType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LEGACY_OWNER": 1,
                      "UNIT_LOGIN": 2,
                      "MOBILE_STAFF": 3,
                      "ELDM": 4
                    }
                  },
                  "RoleAssignmentInfo": {
                    "fields": {
                      "roleToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "authorizedUnitTokens": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "overridePermissions": {
                        "type": ".squareup.roster.mds.EmployeePermissions",
                        "id": 4,
                        "rule": "optional"
                      },
                      "canAccessAllUnits": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "MerchantCbdData": {
                "fields": {
                  "isCbdSeller": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ContactMethod": {
                "fields": {
                  "verificationStatus": {
                    "type": ".squareup.roster.mds.ContactMethod.VerificationStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "verifiedTimestamp": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "uses": {
                    "type": ".squareup.roster.mds.ContactMethod.ContactType",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "phone": {
                    "type": ".squareup.roster.mds.PhoneContactMethod",
                    "id": 1
                  },
                  "email": {
                    "type": ".squareup.roster.mds.EmailContactMethod",
                    "id": 2
                  }
                },
                "nested": {
                  "VerificationStatus": {
                    "values": {
                      "UNKNOWN": 0,
                      "THIRD_PARTY_SUPPLIED": 1,
                      "NEVER_VERIFIED": 2,
                      "VERIFIED": 3
                    }
                  },
                  "ContactType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "DEFAULT": 1,
                      "TRANSACTION_NOTIFICATION": 2,
                      "MERCHANT_SUPPLIED": 3,
                      "RECEIPTS": 4,
                      "CHECKOUT_NOTIFICATION": 5
                    }
                  },
                  "type": {
                    "oneof": ["phone", "email"]
                  }
                }
              },
              "PhoneContactMethod": {
                "fields": {
                  "phoneNumber": {
                    "type": ".squareup.common.location.Phone",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EmailContactMethod": {
                "fields": {
                  "emailAddress": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerchantCreditData": {
                "fields": {
                  "enableCreditCardHoldRate": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "servicer": {
                    "type": ".squareup.roster.mds.MerchantCreditData.Servicer",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "CAPITAL"
                    }
                  },
                  "enableLineOfCreditHoldRate": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Servicer": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CAPITAL": 1,
                      "LOAN_GATEWAY": 2
                    }
                  }
                }
              },
              "MerchantDeveloperContact": {
                "fields": {
                  "uuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "medium": {
                    "oneof": ["emailAddress"]
                  }
                }
              },
              "MerchantDeveloperContactData": {
                "fields": {
                  "contacts": {
                    "type": ".squareup.roster.mds.MerchantDeveloperContact",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "appMarketplaceContacts": {
                    "type": ".squareup.roster.mds.MerchantDeveloperContact",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "MerchantRestaurantsData": {
                "fields": {
                  "restaurantsJoinedAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerchantSfsCoreData": {
                "fields": {
                  "usesSavings": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MerchantRetailData": {
                "fields": {
                  "merchantOnboardingData": {
                    "type": ".squareup.roster.mds.MerchantRetailData.MerchantRetailOnboardingData",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "WebPlatform": {
                    "values": {
                      "WEB_PLATFORM_DO_NOT_USE": 0,
                      "SHOPIFY": 1
                    }
                  },
                  "MerchantRetailOnboardingData": {
                    "fields": {
                      "websiteUrl": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "webPlatform": {
                        "type": ".squareup.roster.mds.MerchantRetailData.WebPlatform",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "AppDataEntry": {
                "fields": {
                  "application": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AddressTypeScope": {
                "fields": {},
                "nested": {
                  "AddressType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SHIPPING": 1,
                      "RECEIPT": 2,
                      "LEGAL": 3,
                      "PHYSICAL": 4,
                      "PAYMENTS": 5,
                      "MARKETING": 6,
                      "PAYMENTS_AUTHORIZATION": 7,
                      "PAYMENTS_ACTIVATION": 8
                    }
                  }
                }
              },
              "AddressEntry": {
                "fields": {
                  "addressToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "agrexCode": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "uses": {
                    "type": ".squareup.roster.mds.AddressTypeScope.AddressType",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "isCorrected": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "recipient": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 1,
                    "rule": "optional"
                  },
                  "careOf": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 4,
                    "rule": "optional"
                  },
                  "shippingPhoneNumber": {
                    "type": ".squareup.common.location.Phone",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isPersonal": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedTs": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "scriptAddresses": {
                    "type": ".squareup.roster.mds.ScriptAddress",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "verification": {
                    "type": ".squareup.common.address.Verification",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "ScriptAddress": {
                "fields": {
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  },
                  "script": {
                    "type": ".squareup.roster.mds.ScriptScope.Script",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaymentFlowPreferences": {
                "fields": {}
              },
              "ApplicationAllowed": {
                "fields": {
                  "application": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.roster.mds.ApplicationAllowed.ApprovalStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ApprovalStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "APPROVED": 1,
                      "CONFIRMATION_REQUESTED": 2,
                      "CONFIRMATION_SUBMITTED": 3,
                      "CONFIRMATION_TIMED_OUT": 4,
                      "DECLINED": 5,
                      "ERROR": 6,
                      "IGNORED": 7,
                      "MANUAL_REVIEW": 8,
                      "MORE_INFORMATION_REQUESTED": 9,
                      "MORE_INFORMATION_SUBMITTED": 10,
                      "PENDING_APPROVAL": 11,
                      "REQUESTED": 12,
                      "SUBMITTED": 13
                    }
                  }
                }
              },
              "UnderwritingComplianceFlags": {
                "fields": {
                  "acceptPaymentCards": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "acceptHighTransactionAmounts": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "acceptInvoiceInstallmentLoans": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "acceptInvoiceInstallmentLoansBlacklist": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "declineAllAuths": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "notSendMoneyThroughPayroll": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "rejectAllRefunds": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "squareupDailyInJp": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "acceptJpyJcbPaymentCards": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "activateSquareCardProcessing": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "overrideAuUnsupportedBusiness": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "hasCompletedPayrollOnboarding": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "MerchantCapabilities": {
                "fields": {
                  "useSavings": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "usePointOfSale": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "useDeveloperDashboard": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "useAppointments": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "useRestaurants": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "usePayroll": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sellCbd": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "useRuleBasedTaxes": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "useItemsAutosku": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sellCannabis": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isSandbox": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "useBtcTreasury": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "useElevatedTipLimit": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "useGiftCards": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "appleTapToPayEnabled": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "appleTapToPayLinked": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional"
                  },
                  "appleTapToPayOptInSeen": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional"
                  },
                  "useHouseAccounts": {
                    "type": "int64",
                    "id": 18,
                    "rule": "optional"
                  },
                  "changeNameWithoutLimit": {
                    "type": "int64",
                    "id": 19,
                    "rule": "optional"
                  },
                  "useGiftCardSettlement": {
                    "type": "int64",
                    "id": 20,
                    "rule": "optional"
                  },
                  "isTestMerchant": {
                    "type": "int64",
                    "id": 21,
                    "rule": "optional"
                  },
                  "appleTapToPayMkeDismissed": {
                    "type": "int64",
                    "id": 22,
                    "rule": "optional"
                  },
                  "paymentLinkMkeDismissed": {
                    "type": "int64",
                    "id": 23,
                    "rule": "optional"
                  },
                  "invoiceMkeDismissed": {
                    "type": "int64",
                    "id": 24,
                    "rule": "optional"
                  },
                  "useDualModeV2Payg": {
                    "type": "int64",
                    "id": 25,
                    "rule": "optional"
                  },
                  "useDualModeV2Pos": {
                    "type": "int64",
                    "id": 26,
                    "rule": "optional"
                  },
                  "useThirdPartyGiftCardProvider": {
                    "type": "int64",
                    "id": 27,
                    "rule": "optional"
                  },
                  "enableModernMicrosMode": {
                    "type": "int64",
                    "id": 28,
                    "rule": "optional"
                  },
                  "reprice16CpAuRates": {
                    "type": "int64",
                    "id": 29,
                    "rule": "optional"
                  },
                  "jpSmirfPricingEligible": {
                    "type": "int64",
                    "id": 30,
                    "rule": "optional"
                  },
                  "showThirdPartyGiftCardProviderOnboarding": {
                    "type": "int64",
                    "id": 31,
                    "rule": "optional"
                  }
                }
              },
              "UnitCapabilities": {
                "fields": {
                  "acceptPaymentCards": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acceptHighTransactions": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "acceptJpyJcbPaymentCards": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "declineAllAuthorizations": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "overrideAuUnsupportedBusiness": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "rejectAllRefunds": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "skipPaymentTutorials": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "getIntroductoryPaymentNotice": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "checkForLoanWithholdings": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "useLocalOffersBilling": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isTestUnit": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "acceptPaymentsAnywhere": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "checkForRiskReserves": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "BusinessIds": {
                "fields": {
                  "ieVatNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "euVatNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "frSiret": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "frNaf": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "frRcs": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "frRcsPlace": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "gbVatNumber": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "esNif": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "jpQiiNumber": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "auAbn": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "auAcn": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "ScriptScope": {
                "fields": {},
                "nested": {
                  "Script": {
                    "values": {
                      "Zyyy": 998,
                      "Hebr": 125,
                      "Arab": 160,
                      "Latn": 215,
                      "Grek": 200,
                      "Cyrl": 220,
                      "Hang": 286,
                      "Kore": 287,
                      "Deva": 315,
                      "Beng": 325,
                      "Taml": 346,
                      "Thai": 352,
                      "Hira": 410,
                      "Kana": 411,
                      "Hrkt": 412,
                      "Jpan": 413,
                      "Hani": 500
                    }
                  }
                }
              },
              "Name": {
                "fields": {
                  "script": {
                    "type": ".squareup.roster.mds.ScriptScope.Script",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Names": {
                "fields": {
                  "primary": {
                    "type": ".squareup.roster.mds.Name",
                    "id": 1,
                    "rule": "optional"
                  },
                  "others": {
                    "type": ".squareup.roster.mds.Name",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "EntityToken": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 3
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 4
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 5
                  },
                  "personToken": {
                    "type": "string",
                    "id": 6
                  }
                },
                "nested": {
                  "type": {
                    "oneof": ["merchantToken", "unitToken", "employmentToken", "personToken"]
                  }
                }
              },
              "ApplicationScope": {
                "fields": {},
                "nested": {
                  "Application": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PAYMENTS": 1,
                      "APPOINTMENTS": 2,
                      "PAYROLL": 3,
                      "POINT_OF_SALE": 4,
                      "MULTIPASS": 5,
                      "LEGACY": 6,
                      "LEGACY_ROLLOUT": 15,
                      "ONLINE_STORE": 7,
                      "BILLING": 8,
                      "HOURS": 9,
                      "BRAND": 10,
                      "EMPLOYEES": 11,
                      "SECURITY": 12,
                      "RECEIPTS": 13,
                      "LOCATION": 14,
                      "GIFTCARDS": 16,
                      "INTERNAL": 17,
                      "ACTIVATION": 18,
                      "ECOMMERCE_BRIDGE": 19,
                      "POS_SERVICE_SETTINGS": 20,
                      "TERMINAL": 21,
                      "BIZBANK": 22,
                      "CBD": 29,
                      "CONVERSATIONS": 30,
                      "EMPLOYEE_MANAGEMENT_SUBSCRIPTION": 23,
                      "INSTALLMENTS": 24,
                      "PAYMENT_CONFIGURATIONS": 25,
                      "INFERRED_PROFILE": 26,
                      "INVOICES": 27,
                      "ORDERS": 28,
                      "RISK_MANAGER": 31,
                      "DEVELOPER_CONTACT": 32,
                      "RESTAURANTS": 33,
                      "MARKETING": 34,
                      "BANKING": 35,
                      "SFS_CORE": 36,
                      "RETAIL": 37,
                      "CREDIT": 38
                    }
                  }
                }
              },
              "FetchFlagScope": {
                "fields": {},
                "nested": {
                  "FetchFlag": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "APP_DATA_ONLY": 1,
                      "ADDRESS": 2,
                      "MERCHANT": 5,
                      "UNIT": 6,
                      "EMPLOYMENT": 7,
                      "EMPLOYEE_ROLE": 8,
                      "EXPAND_AUTHORIZED_MERCHANT_UNITS": 9,
                      "MAIN_UNIT": 12,
                      "OLDEST_UNIT_TOKEN": 13,
                      "PAYMENTS_AUTHORIZATION_ADDRESS": 14,
                      "VAULTED": 15,
                      "ACCESS_BLOCKERS": 16,
                      "PAYMENTS_ACTIVATION_ADDRESS": 17
                    }
                  }
                }
              },
              "StatusScope": {
                "fields": {},
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ACTIVE": 1,
                      "DELETED": 2
                    }
                  }
                }
              },
              "ErrorScope": {
                "fields": {},
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_TOKEN": 1,
                      "INVALID_TOKEN_TYPE": 2,
                      "APP_DATA_TOO_LARGE": 3,
                      "UNSUPPORTED_APPLICATION_TYPE": 4,
                      "NOT_ALLOWED": 5,
                      "INVALID_VERSION": 6
                    }
                  }
                }
              },
              "Permission": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "public": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.roster.mds.Permission.PermissionState",
                    "id": 3,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PermissionState": {
                    "values": {
                      "INVALID": 0,
                      "USER": 1,
                      "ALL": 2,
                      "NONE": 3
                    }
                  }
                }
              },
              "TokenTypeScope": {
                "fields": {},
                "nested": {
                  "TokenType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "EMPLOYMENT": 1,
                      "MERCHANT": 3,
                      "UNIT": 4
                    }
                  }
                }
              },
              "DecodedAppDataEntry": {
                "fields": {
                  "appDataEntry": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 1,
                    "rule": "optional"
                  },
                  "legacyRolloutData": {
                    "type": ".squareup.roster.mds.LegacyRolloutData",
                    "id": 2
                  },
                  "employmentEmployeesData": {
                    "type": ".squareup.roster.mds.EmploymentEmployeesData",
                    "id": 4
                  },
                  "employmentLegacyData": {
                    "type": ".squareup.roster.mds.EmploymentLegacyData",
                    "id": 5
                  },
                  "employmentPayrollData": {
                    "type": ".squareup.roster.mds.EmploymentPayrollData",
                    "id": 6
                  },
                  "employmentInternalData": {
                    "type": ".squareup.roster.mds.EmploymentInternalData",
                    "id": 22
                  },
                  "merchantAppointmentsData": {
                    "type": ".squareup.roster.mds.MerchantAppointmentsData",
                    "id": 27
                  },
                  "merchantBillingData": {
                    "type": ".squareup.roster.mds.MerchantBillingData",
                    "id": 8
                  },
                  "merchantEmSubscriptionData": {
                    "type": ".squareup.roster.mds.MerchantEmSubscriptionData",
                    "id": 29
                  },
                  "merchantGiftcardsData": {
                    "type": ".squareup.roster.mds.MerchantGiftCardsData",
                    "id": 9
                  },
                  "merchantLegacyData": {
                    "type": ".squareup.roster.mds.MerchantLegacyData",
                    "id": 10
                  },
                  "merchantMarketingData": {
                    "type": ".squareup.roster.mds.MerchantMarketingData",
                    "id": 32
                  },
                  "merchant_MultipassData": {
                    "type": ".squareup.roster.mds.MerchantMultipassData",
                    "id": 23
                  },
                  "merchantPaymentData": {
                    "type": ".squareup.roster.mds.MerchantPaymentData",
                    "id": 11
                  },
                  "merchantPosData": {
                    "type": ".squareup.roster.mds.MerchantPosData",
                    "id": 12
                  },
                  "merchantCbdData": {
                    "type": ".squareup.roster.mds.MerchantCbdData",
                    "id": 28
                  },
                  "merchantRestaurantsData": {
                    "type": ".squareup.roster.mds.MerchantRestaurantsData",
                    "id": 30
                  },
                  "merchantSfsCoreData": {
                    "type": ".squareup.roster.mds.MerchantSfsCoreData",
                    "id": 34
                  },
                  "merchantRetailData": {
                    "type": ".squareup.roster.mds.MerchantRetailData",
                    "id": 35
                  },
                  "merchantCreditData": {
                    "type": ".squareup.roster.mds.MerchantCreditData",
                    "id": 36
                  },
                  "unitBrandData": {
                    "type": ".squareup.roster.mds.UnitBrandData",
                    "id": 13
                  },
                  "unitHoursData": {
                    "type": ".squareup.roster.mds.UnitHoursData",
                    "id": 14
                  },
                  "unitLegacyData": {
                    "type": ".squareup.roster.mds.UnitLegacyData",
                    "id": 15
                  },
                  "unitLocationData": {
                    "type": ".squareup.roster.mds.UnitLocationData",
                    "id": 16
                  },
                  "unitOnlineStoreData": {
                    "type": ".squareup.roster.mds.UnitOnlineStoreData",
                    "id": 17
                  },
                  "unitPaymentData": {
                    "type": ".squareup.roster.mds.UnitPaymentData",
                    "id": 18
                  },
                  "unitPosData": {
                    "type": ".squareup.roster.mds.UnitPosData",
                    "id": 19
                  },
                  "unitReceiptsData": {
                    "type": ".squareup.roster.mds.UnitReceiptsData",
                    "id": 20
                  },
                  "unitSecurityData": {
                    "type": ".squareup.roster.mds.UnitSecurityData",
                    "id": 21
                  },
                  "unitBillingData": {
                    "type": ".squareup.roster.mds.UnitBillingData",
                    "id": 24
                  },
                  "unitActivationData": {
                    "type": ".squareup.roster.mds.UnitActivationData",
                    "id": 25
                  },
                  "unitPosServiceSettingsData": {
                    "type": ".squareup.roster.mds.UnitPosServiceSettingsData",
                    "id": 26
                  },
                  "unitBankingData": {
                    "type": ".squareup.roster.mds.UnitBankingData",
                    "id": 33
                  }
                },
                "nested": {
                  "app_data_message": {
                    "oneof": ["legacyRolloutData", "employmentEmployeesData", "employmentLegacyData", "employmentPayrollData", "employmentInternalData", "merchantAppointmentsData", "merchantBillingData", "merchantEmSubscriptionData", "merchantGiftcardsData", "merchantLegacyData", "merchantMarketingData", "merchant_MultipassData", "merchantPaymentData", "merchantPosData", "merchantCbdData", "merchantRestaurantsData", "merchantSfsCoreData", "merchantRetailData", "merchantCreditData", "unitBrandData", "unitHoursData", "unitLegacyData", "unitLocationData", "unitOnlineStoreData", "unitPaymentData", "unitPosData", "unitReceiptsData", "unitSecurityData", "unitBillingData", "unitActivationData", "unitPosServiceSettingsData", "unitBankingData"]
                  }
                }
              },
              "ProfanityFilteredFieldScope": {
                "fields": {},
                "nested": {
                  "ProfanityFilteredField": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "MERCHANT_NAME": 1,
                      "UNIT_NAME": 2,
                      "UNIT_NICKNAME": 3,
                      "UNIT_SPECIAL_HOURS_REASON": 4,
                      "UNIT_DESCRIPTION": 5,
                      "UNIT_RETURN_POLICY": 6,
                      "UNIT_RECEIPT_MESSAGE": 7
                    }
                  }
                }
              },
              "FindMerchantsRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.MerchantQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FindMerchantTokensRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.MerchantQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MerchantQuery": {
                "fields": {
                  "legacyUserId": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FindTokensResponse": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FindMerchantsResponse": {
                "fields": {
                  "results": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantResponse": {
                "fields": {
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LegacyGetMerchantRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantForPlatformAccountRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "BatchGetMerchantRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 200
                    }
                  }
                }
              },
              "BatchGetMerchantResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetMerchantResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "merchant": {
                        "type": ".squareup.roster.mds.Merchant",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetUnitsForMerchantRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetUnitsForMerchantResponse": {
                "fields": {
                  "results": {
                    "type": ".squareup.roster.mds.UnitInfo",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FindUnitsRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.UnitQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FindUnitTokensRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.UnitQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UnitQuery": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "legacyUserId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "onlineStoreSlug": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.roster.mds.StatusScope.Status",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "FindUnitsResponse": {
                "fields": {
                  "results": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetUnitRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetUnitResponse": {
                "fields": {
                  "unit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BatchGetUnitRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 200
                    }
                  }
                }
              },
              "BatchGetUnitResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetUnitResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "unit": {
                        "type": ".squareup.roster.mds.Unit",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UpdateMerchantAppDataRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantAppDataResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ErrorScope.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUnitAppDataRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUnitAppDataResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ErrorScope.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantAddressesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressData": {
                    "type": ".squareup.roster.mds.AddressEntry",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantAddressesResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.UpdateMerchantAddressesResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_TOKEN": 1,
                      "INVALID_TOKEN_TYPE": 2,
                      "ADDRESS_DATA_TOO_LARGE": 3,
                      "UNSUPPORTED_ADDRESS_TYPE": 4,
                      "NOT_ALLOWED": 5
                    }
                  }
                }
              },
              "UpdateMerchantCapabilitiesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "enableCapabilities": {
                    "type": ".squareup.roster.mds.UpdateMerchantCapabilitiesRequest.MerchantCapability",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "disableCapabilities": {
                    "type": ".squareup.roster.mds.UpdateMerchantCapabilitiesRequest.MerchantCapability",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCapability": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "USE_SAVINGS": 1,
                      "USE_POINT_OF_SALE": 2,
                      "USE_DEVELOPER_DASHBOARD": 3,
                      "USE_APPOINTMENTS": 4,
                      "USE_RESTAURANTS": 5,
                      "USE_PAYROLL": 6,
                      "SELL_CBD": 7,
                      "USE_RULE_BASED_TAXES": 8,
                      "USE_ITEMS_AUTOSKU": 9,
                      "SELL_CANNABIS": 10,
                      "IS_SANDBOX": 11,
                      "USE_BTC_TREASURY": 12,
                      "USE_ELEVATED_TIP_LIMIT": 13,
                      "USE_GIFT_CARDS": 14,
                      "APPLE_TAP_TO_PAY_ENABLED": 15,
                      "APPLE_TAP_TO_PAY_LINKED": 16,
                      "APPLE_TAP_TO_PAY_OPT_IN_SEEN": 17,
                      "USE_HOUSE_ACCOUNTS": 18,
                      "CHANGE_NAME_WITHOUT_LIMIT": 19,
                      "USE_GIFT_CARD_SETTLEMENT": 20,
                      "APPLE_TAP_TO_PAY_MKE_DISMISSED": 21,
                      "PAYMENT_LINK_MKE_DISMISSED": 22,
                      "INVOICE_MKE_DISMISSED": 23,
                      "USE_DUAL_MODE_V2_PAYG": 24,
                      "USE_DUAL_MODE_V2_POS": 25,
                      "USE_THIRD_PARTY_GIFT_CARD_PROVIDER": 26,
                      "ENABLE_MODERN_MICROS_MODE": 27,
                      "REPRICE_1_6_CP_AU_RATES": 28,
                      "JP_SMIRF_PRICING_ELIGIBLE": 29,
                      "SHOW_THIRD_PARTY_GIFT_CARD_PROVIDER_ONBOARDING": 30
                    }
                  }
                }
              },
              "UpdateMerchantCapabilitiesResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ErrorScope.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantTwoFactorStateRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "twoFactorState": {
                    "type": ".squareup.common.twofactor.TwoFactorState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantTwoFactorStateResponse": {
                "fields": {
                  "previousTwoFactorState": {
                    "type": ".squareup.common.twofactor.TwoFactorState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "newTwoFactorState": {
                    "type": ".squareup.common.twofactor.TwoFactorState",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUnitCapabilitiesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "enableCapabilities": {
                    "type": ".squareup.roster.mds.UpdateUnitCapabilitiesRequest.UnitCapability",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "disableCapabilities": {
                    "type": ".squareup.roster.mds.UpdateUnitCapabilitiesRequest.UnitCapability",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "UnitCapability": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ACCEPT_PAYMENT_CARDS": 1,
                      "ACCEPT_HIGH_TRANSACTIONS": 2,
                      "ACCEPT_JPY_JCB_PAYMENT_CARDS": 3,
                      "DECLINE_ALL_AUTHORIZATIONS": 4,
                      "OVERRIDE_AU_UNSUPPORTED_BUSINESS": 5,
                      "REJECT_ALL_REFUNDS": 6,
                      "SKIP_PAYMENT_TUTORIALS": 7,
                      "GET_INTRODUCTORY_PAYMENT_NOTICE": 8,
                      "CHECK_FOR_LOAN_WITHHOLDINGS": 9,
                      "USE_LOCAL_OFFERS_BILLING": 10,
                      "ACCEPT_PAYMENTS_ANYWHERE": 12,
                      "CHECK_FOR_RISK_RESERVES": 13
                    }
                  }
                }
              },
              "UpdateUnitCapabilitiesResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ErrorScope.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FindEmploymentsV2Request": {
                "fields": {
                  "employmentFilter": {
                    "type": ".squareup.roster.mds.EgEmploymentFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employmentSortOrder": {
                    "type": ".squareup.roster.mds.EgEmploymentSortOrder",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "EgEmploymentFilter": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "personTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "isActive": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "hasPersonId": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isAuthorizedUser": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "firstNames": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "lastNames": {
                    "type": "string",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "phoneNumbers": {
                    "type": "string",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "emails": {
                    "type": "string",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "roleFilter": {
                    "type": ".squareup.roster.mds.EgEmployeeRoleFilter",
                    "id": 11,
                    "rule": "optional"
                  },
                  "authorizedLocationFilter": {
                    "type": ".squareup.roster.mds.EgLocationFilter",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "EgEmploymentSortOrder": {
                "values": {
                  "TOKEN_ASC": 0,
                  "TOKEN_DESC": 1,
                  "FIRST_NAME_LAST_NAME_ASC": 2,
                  "FIRST_NAME_LAST_NAME_DESC": 3,
                  "ACTIVE_ASC": 4,
                  "ACTIVE_DESC": 5
                }
              },
              "EgEmployeeRoleFilter": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "roleTypes": {
                    "type": ".squareup.roster.mds.EmployeeRole.RoleType",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "isFullAccessRole": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "EgLocationFilter": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "names": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "statuses": {
                    "type": ".squareup.roster.mds.StatusScope.Status",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "countries": {
                    "type": ".squareup.common.countries.Country",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "EgEmployment": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "roleTokens": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "active": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isAuthorizedUser": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "authorizedUnitTokens": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "overridePermissions": {
                    "type": ".squareup.employees.EmployeePermissionFlags",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "hasPasscode": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "passcodeCreatedAt": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "userId": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              },
              "FindEmploymentsV2Response": {
                "fields": {
                  "employments": {
                    "type": ".squareup.roster.mds.EgEmployment",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FindEmploymentsRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.EmploymentQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FindEmploymentTokensRequest": {
                "fields": {
                  "queries": {
                    "type": ".squareup.roster.mds.EmploymentQuery",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "EmploymentQuery": {
                "fields": {
                  "personToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employeeRoleToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "updatedSinceTs": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isAdmin": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "hasPerson": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isAuthorizedUser": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "merchantSuppliedEmail": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "FindEmploymentsResponse": {
                "fields": {
                  "results": {
                    "type": ".squareup.roster.mds.Employment",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetEmploymentRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetEmploymentResponse": {
                "fields": {
                  "employment": {
                    "type": ".squareup.roster.mds.Employment",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BatchGetEmploymentRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "applications": {
                    "type": ".squareup.roster.mds.ApplicationScope.Application",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "fetchFlags": {
                    "type": ".squareup.roster.mds.FetchFlagScope.FetchFlag",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 200
                    }
                  }
                }
              },
              "BatchGetEmploymentResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetEmploymentResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "employment": {
                        "type": ".squareup.roster.mds.Employment",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetNumberOfEmploymentsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetNumberOfEmploymentsResponse": {
                "fields": {
                  "numberOfEmployments": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetEmploymentsForMerchantRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeInactive": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetEmploymentsForMerchantResponse": {
                "fields": {
                  "employments": {
                    "type": ".squareup.roster.mds.EmploymentLite",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GenerateEmploymentPasscodeRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GenerateEmploymentPasscodeResponse": {
                "fields": {
                  "passcode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.roster.mds.GenerateEmploymentPasscodeResponse.Error",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NO_PASSCODES_REMAINING": 1,
                      "UNABLE_TO_GENERATE_PASSCODE": 2
                    }
                  }
                }
              },
              "UpdateEmploymentPasscodeRequest": {
                "fields": {
                  "removePasscode": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "passcode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 5,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 1
                  },
                  "employeeRoleToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "entity_token": {
                    "oneof": ["employmentToken", "employeeRoleToken"]
                  }
                }
              },
              "UpdateEmploymentPasscodeResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.UpdateEmploymentPasscodeResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "passcode": {
                    "type": ".squareup.roster.mds.EmployeePasscode",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PASSCODE_CONFLICT": 1,
                      "INVALID_PASSCODE": 2
                    }
                  }
                }
              },
              "ValidateEmploymentPasscodeRequest": {
                "fields": {
                  "passcode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 1
                  },
                  "employeeRoleToken": {
                    "type": "string",
                    "id": 2
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 4
                  }
                },
                "nested": {
                  "entity_token": {
                    "oneof": ["employmentToken", "employeeRoleToken", "merchantToken"]
                  }
                }
              },
              "ValidateEmploymentPasscodeResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ValidateEmploymentPasscodeResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PASSCODE_CONFLICT": 1,
                      "INVALID_PASSCODE": 2
                    }
                  }
                }
              },
              "EmploymentForPos": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "employeeNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 4,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": ".squareup.roster.mds.Names",
                    "id": 5,
                    "rule": "optional"
                  },
                  "passcode": {
                    "type": ".squareup.roster.mds.EmployeePasscode",
                    "id": 6,
                    "rule": "optional"
                  },
                  "roleAssignments": {
                    "type": ".squareup.roster.mds.EmployeeRoleAssignment",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "ListEmploymentsForPosRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 1000
                    }
                  }
                }
              },
              "ListEmploymentsForPosResponse": {
                "fields": {
                  "employments": {
                    "type": ".squareup.roster.mds.EmploymentForPos",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateEmploymentAppDataRequest": {
                "fields": {
                  "employmentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appData": {
                    "type": ".squareup.roster.mds.AppDataEntry",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateEmploymentAppDataResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ErrorScope.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListPermissionsRequest": {
                "fields": {}
              },
              "ListPermissionsResponse": {
                "fields": {
                  "permissions": {
                    "type": ".squareup.roster.mds.Permission",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "LookupTokenTypeRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LookupTokenTypeResponse": {
                "fields": {
                  "token": {
                    "type": ".squareup.roster.mds.EntityToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tokenTypes": {
                    "type": ".squareup.roster.mds.TokenTypeScope.TokenType",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "BatchLookupTokenTypeRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 100
                    }
                  }
                }
              },
              "BatchLookupTokenTypeResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchLookupTokenTypeResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "tokenTypes": {
                        "type": ".squareup.roster.mds.TokenTypeScope.TokenType",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "BatchGetTokenForIdRequest": {
                "fields": {
                  "legacyUserIds": {
                    "type": "int64",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 100
                    }
                  }
                }
              },
              "BatchGetTokenForIdResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetTokenForIdResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "legacyUserId": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 3
                      }
                    },
                    "nested": {
                      "token": {
                        "oneof": ["merchantToken", "unitToken"]
                      }
                    }
                  }
                }
              },
              "FindEmployeeRolesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeRoleTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "roleTypes": {
                    "type": ".squareup.roster.mds.EmployeeRole.RoleType",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "FindEmployeeRolesResponse": {
                "fields": {
                  "employeeRoles": {
                    "type": ".squareup.roster.mds.EmployeeRole",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CreateMerchantRequest": {
                "fields": {
                  "countryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "password": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "preferredLanguage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ipAddress": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "creatorApplicationId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "platformAccountToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "platformHidden": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "ownerFirstName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "ownerLastName": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "merchantCapabilities": {
                    "type": ".squareup.roster.mds.CreateMerchantRequest.MerchantCapability",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 15,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "allowMultipleMerchants": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "businessUnit": {
                    "type": ".squareup.roster.mds.BusinessUnit",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCapability": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "POINT_OF_SALE": 1,
                      "DEVELOPER": 2,
                      "SAVINGS": 3,
                      "SANDBOX": 4,
                      "TEST_MERCHANT": 5
                    }
                  }
                }
              },
              "CreateMerchantResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.CreateMerchantResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "existingMerchant": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 7,
                    "rule": "optional"
                  },
                  "profaneField": {
                    "type": ".squareup.roster.mds.ProfanityFilteredFieldScope.ProfanityFilteredField",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isActive": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "EMAIL_TAKEN": 1,
                      "EMAIL_INVALID": 2,
                      "PASSWORD_COMMON": 3,
                      "PASSWORD_COMPROMISED": 4,
                      "PASSWORD_REUSE": 8,
                      "PASSWORD_FAILS_REQUIREMENTS": 5,
                      "INVALID_ACCOUNT": 6,
                      "TEMPORARY_LOCKOUT": 9,
                      "CREDENTIAL_ERROR": 7,
                      "PROFANITY_DETECTED": 10,
                      "MAX_ALLOWED_TEST_MERCHANTS_LIMIT_REACHED": 11
                    }
                  }
                }
              },
              "GetEmploymentsForPersonRequest": {
                "fields": {
                  "credentialToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "onMaster": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "GetEmploymentsForPersonResponse": {
                "fields": {
                  "employment": {
                    "type": ".squareup.employees.Employment",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "mdsEmployment": {
                    "type": ".squareup.roster.mds.Employment",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "onMaster": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "credentialToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ChangeOwnerRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "newOwnerPersonToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ChangeOwnerResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.roster.mds.ChangeOwnerResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "MERCHANT_TOKEN_INVALID": 1,
                      "PERSON_TOKEN_INVALID": 2,
                      "INTERNAL_ERROR": 3
                    }
                  }
                }
              },
              "BatchGetOwnerPersonTokenRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 100
                    }
                  }
                }
              },
              "BatchGetOwnerPersonTokenResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetOwnerPersonTokenResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "personToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UpdateUnitPaymentsPermissionRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "acceptPaymentCards": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actorMerchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CompleteEmployeeSignupResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.roster.mds.CompleteEmployeeSignupResponse.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "DUPLICATE_PERSON_TOKEN": 1
                    }
                  }
                }
              },
              "CreateOrUpdateEmploymentResponse": {
                "fields": {},
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_MERCHANT": 1,
                      "INVALID_EMPLOYMENT": 2,
                      "DUPLICATE_PERSON_TOKEN": 3,
                      "DUPLICATE_MERCHANT_SUPPLIED_EMAIL": 4,
                      "INVALID_UNITS": 5,
                      "INVALID_ROLES": 6,
                      "ACCOUNT_OWNER_CHANGE": 7,
                      "ACCOUNT_OWNER_FIRST_NAME_CHANGE": 8,
                      "ACCOUNT_OWNER_LAST_NAME_CHANGE": 9
                    }
                  }
                }
              },
              "CreateEmploymentRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmploymentPayload",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "UpdateEmploymentRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmploymentPayload",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateOrUpdateEmploymentPayload": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isActive": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employeeNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantSuppliedEmail": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "wageType": {
                    "type": ".squareup.roster.mds.EmploymentPayrollData.WageType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "annualWageCents": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "hourlyWageCents": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "hoursWorkedPerWeek": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "flsaExempt": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "employeeRoleTokens": {
                    "type": "string",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "subunitTokens": {
                    "type": "string",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "addSubunitTokens": {
                    "type": "string",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "isAuthorizedUser": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "removeFields": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmploymentPayload.RemoveField",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "canAccessAllUnits": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "canAccessPayroll": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RemoveField": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "EMPLOYEE_NUMBER": 1,
                      "FIRST_NAME": 2,
                      "LAST_NAME": 3,
                      "MERCHANT_SUPPLIED_EMAIL": 4,
                      "PHONE_NUMBER": 5,
                      "WAGE_TYPE": 6,
                      "ANNUAL_WAGE_CENTS": 7,
                      "HOURLY_WAGE_CENTS": 8,
                      "HOURS_WORKED_PER_WEEK": 9,
                      "UNIT_AUTHORIZATION": 10,
                      "EMPLOYEE_ROLE": 11
                    }
                  }
                }
              },
              "CreateEmploymentResponse": {
                "fields": {
                  "employmentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employment": {
                    "type": ".squareup.roster.mds.Employment",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmploymentResponse.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateEmploymentResponse": {
                "fields": {
                  "employmentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employment": {
                    "type": ".squareup.roster.mds.Employment",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmploymentResponse.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreateOrUpdateEmployeeRolePayload": {
                "fields": {
                  "employeeRoleToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeRoleName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "managedRoles": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmployeeRolePayload.ManagedRoles",
                    "id": 4,
                    "rule": "optional"
                  },
                  "roleType": {
                    "type": ".squareup.roster.mds.EmployeeRole.RoleType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isFreeRole": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isAdminRole": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ManagedRoles": {
                    "fields": {
                      "managedRoleTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "CreateEmployeeRoleRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmployeeRolePayload",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateEmployeeRoleResponse": {
                "fields": {
                  "employeeRole": {
                    "type": ".squareup.roster.mds.EmployeeRole",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateEmployeeRoleRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": ".squareup.roster.mds.CreateOrUpdateEmployeeRolePayload",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateEmployeeRoleResponse": {
                "fields": {
                  "employeeRole": {
                    "type": ".squareup.roster.mds.EmployeeRole",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeleteEmployeeRoleRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeRoleToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateUnitResponse": {
                "fields": {
                  "unit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.roster.mds.CreateUnitResponse.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "profaneField": {
                    "type": ".squareup.roster.mds.ProfanityFilteredFieldScope.ProfanityFilteredField",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_MERCHANT": 1,
                      "MAXIMUM_UNITS_REACHED": 2,
                      "NICKNAME_NOT_UNIQUE": 3,
                      "INVALID_INSTAGRAM_USERNAME": 4,
                      "PROFANITY_DETECTED": 5,
                      "INVALID_ADDRESS_LINE": 6,
                      "INVALID_POSTAL_CODE": 7,
                      "INVALID_ADMIN_LEVEL_1": 8
                    }
                  }
                }
              },
              "DeactivateMerchantResponse": {
                "fields": {}
              },
              "DeleteEmployeeRoleResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.roster.mds.DeleteEmployeeRoleResponse.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ASSIGNED_TO_ACTIVE_EMPLOYMENTS": 1,
                      "ACCOUNT_OWNER_ROLE": 2,
                      "GUEST_ROLE": 3
                    }
                  }
                }
              },
              "MigrateMerchantToNativeStorageResponse": {
                "fields": {}
              },
              "MultiunitUpgradeResponse": {
                "fields": {}
              },
              "ReactivateMerchantResponse": {
                "fields": {}
              },
              "UpdateUserResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.roster.mds.UpdateUserResponse.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "profaneField": {
                    "type": ".squareup.roster.mds.ProfanityFilteredFieldScope.ProfanityFilteredField",
                    "id": 4,
                    "rule": "optional"
                  },
                  "unit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 1
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 2
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INTERNAL_ERROR": 1,
                      "INVALID_TOKEN": 2,
                      "NICKNAME_NOT_UNIQUE": 3,
                      "LAST_ACTIVE_UNIT": 4,
                      "INVALID_INSTAGRAM_USERNAME": 5,
                      "PROFANITY_DETECTED": 6,
                      "BUSINESS_NAME_CHANGE_RATE_LIMIT_EXCEEDED": 7,
                      "KANJI_POSTAL_CODE_INVALID": 8,
                      "KANJI_CHOME_BANCHI_INVALID": 9,
                      "KANJI_BUILDING_NAME_MISSING": 10,
                      "KANA_BUILDING_NAME_MISSING": 11,
                      "KANA_INVALID_CHARACTERS": 12,
                      "KANJI_PREFECTURE_MISSING": 13,
                      "KANJI_CITY_MISSING": 14,
                      "KANJI_AREA_MISSING": 15,
                      "INVALID_ADDRESS_LINE": 16,
                      "INVALID_POSTAL_CODE": 17,
                      "INVALID_ADMIN_LEVEL_1": 18
                    }
                  },
                  "entity": {
                    "oneof": ["unit", "merchant"]
                  }
                }
              },
              "UpdateUnitPaymentsPermissionResponse": {
                "fields": {}
              },
              "ObtainUnitSlugRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ObtainUnitSlugResponse": {
                "fields": {
                  "slug": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BatchGetOwnerForMerchantRequest": {
                "fields": {
                  "merchantTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_BATCH_SIZE": 100
                    }
                  }
                }
              },
              "BatchGetOwnerForMerchantResponse": {
                "fields": {
                  "entries": {
                    "type": ".squareup.roster.mds.BatchGetOwnerForMerchantResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "employment": {
                        "type": ".squareup.roster.mds.Employment",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ReorderUnitPosAdditionalImagesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contentDigestsInOrder": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ReorderUnitPosAdditionalImagesResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contentDigestsInOrder": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "GeocodeUnitRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GeocodeUnitResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.roster.mds.GeocodeUnitResponse.Status",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "DO_NOT_USE"
                    }
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "GEOCODE_SUCCESS": 1,
                      "GEOCODE_FAIL": 2,
                      "UNIT_NOT_FOUND": 3,
                      "ADDRESS_NOT_FOUND": 4,
                      "ADDRESS_CHANGED": 5
                    }
                  }
                }
              },
              "UpdateUnitBrandDataRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardColor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "facebook": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "instagram": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "twitter": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "website": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "images": {
                    "type": ".squareup.roster.mds.ImageEntry",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "removeImages": {
                    "type": ".squareup.roster.mds.ImagePurposeScope.ImagePurpose",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 11,
                    "rule": "optional"
                  },
                  "removeFields": {
                    "type": ".squareup.roster.mds.UpdateUnitBrandDataRequest.RemoveField",
                    "id": 12,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "RemoveField": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_COLOR": 1,
                      "DESCRIPTION": 2,
                      "FACEBOOK": 3,
                      "INSTAGRAM": 4,
                      "TWITTER": 5,
                      "WEBSITE": 6
                    }
                  }
                }
              },
              "UpdateUnitBrandDataResponse": {
                "fields": {
                  "statuses": {
                    "type": ".squareup.roster.mds.UpdateUnitBrandDataResponse.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.roster.mds.UpdateUserResponse.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SUCCESS": 1,
                      "OLD_VERSION": 2,
                      "BAD_VERSION": 3,
                      "INVALID_PAYLOAD": 4,
                      "INTERNAL_ERROR": 5
                    }
                  }
                }
              },
              "UpdateUnitRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.roster.mds.AddressEntry",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "UpdateUnitResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.roster.mds.UpdateUnitResponse.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "unit": {
                    "type": ".squareup.roster.mds.Unit",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INTERNAL_ERROR": 1,
                      "INVALID_TOKEN": 2,
                      "PROFANITY_DETECTED": 3,
                      "BUSINESS_NAME_CHANGE_RATE_LIMIT_EXCEEDED": 4,
                      "INVALID_POSTAL_CODE": 5,
                      "INVALID_ADMIN_LEVEL_1": 6
                    }
                  }
                }
              },
              "UpdateMerchantRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.roster.mds.UpdateMerchantResponse.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "merchant": {
                    "type": ".squareup.roster.mds.Merchant",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INTERNAL_ERROR": 1,
                      "INVALID_TOKEN": 2,
                      "PROFANITY_DETECTED": 3,
                      "BUSINESS_NAME_CHANGE_RATE_LIMIT_EXCEEDED": 4
                    }
                  }
                }
              },
              "MerchantDataService": {
                "methods": {
                  "GeocodeUnit": {
                    "requestType": ".squareup.roster.mds.GeocodeUnitRequest",
                    "responseType": ".squareup.roster.mds.GeocodeUnitResponse"
                  },
                  "FindMerchants": {
                    "requestType": ".squareup.roster.mds.FindMerchantsRequest",
                    "responseType": ".squareup.roster.mds.FindMerchantsResponse"
                  },
                  "GetMerchant": {
                    "requestType": ".squareup.roster.mds.GetMerchantRequest",
                    "responseType": ".squareup.roster.mds.GetMerchantResponse"
                  },
                  "BatchGetMerchant": {
                    "requestType": ".squareup.roster.mds.BatchGetMerchantRequest",
                    "responseType": ".squareup.roster.mds.BatchGetMerchantResponse"
                  },
                  "LegacyGetMerchant": {
                    "requestType": ".squareup.roster.mds.LegacyGetMerchantRequest",
                    "responseType": ".squareup.roster.mds.GetMerchantResponse"
                  },
                  "GetMerchantForPlatformAccount": {
                    "requestType": ".squareup.roster.mds.GetMerchantForPlatformAccountRequest",
                    "responseType": ".squareup.roster.mds.GetMerchantResponse"
                  },
                  "GetUnitsForMerchant": {
                    "requestType": ".squareup.roster.mds.GetUnitsForMerchantRequest",
                    "responseType": ".squareup.roster.mds.GetUnitsForMerchantResponse"
                  },
                  "FindUnitTokens": {
                    "requestType": ".squareup.roster.mds.FindUnitTokensRequest",
                    "responseType": ".squareup.roster.mds.FindTokensResponse"
                  },
                  "FindUnits": {
                    "requestType": ".squareup.roster.mds.FindUnitsRequest",
                    "responseType": ".squareup.roster.mds.FindUnitsResponse"
                  },
                  "GetUnit": {
                    "requestType": ".squareup.roster.mds.GetUnitRequest",
                    "responseType": ".squareup.roster.mds.GetUnitResponse"
                  },
                  "BatchGetUnit": {
                    "requestType": ".squareup.roster.mds.BatchGetUnitRequest",
                    "responseType": ".squareup.roster.mds.BatchGetUnitResponse"
                  },
                  "UpdateUnitAppData": {
                    "requestType": ".squareup.roster.mds.UpdateUnitAppDataRequest",
                    "responseType": ".squareup.roster.mds.UpdateUnitAppDataResponse"
                  },
                  "UpdateMerchantAppData": {
                    "requestType": ".squareup.roster.mds.UpdateMerchantAppDataRequest",
                    "responseType": ".squareup.roster.mds.UpdateMerchantAppDataResponse"
                  },
                  "UpdateMerchantAddresses": {
                    "requestType": ".squareup.roster.mds.UpdateMerchantAddressesRequest",
                    "responseType": ".squareup.roster.mds.UpdateMerchantAddressesResponse"
                  },
                  "FindEmploymentTokens": {
                    "requestType": ".squareup.roster.mds.FindEmploymentTokensRequest",
                    "responseType": ".squareup.roster.mds.FindTokensResponse"
                  },
                  "FindEmployments": {
                    "requestType": ".squareup.roster.mds.FindEmploymentsRequest",
                    "responseType": ".squareup.roster.mds.FindEmploymentsResponse"
                  },
                  "GetEmployment": {
                    "requestType": ".squareup.roster.mds.GetEmploymentRequest",
                    "responseType": ".squareup.roster.mds.GetEmploymentResponse"
                  },
                  "BatchGetEmployment": {
                    "requestType": ".squareup.roster.mds.BatchGetEmploymentRequest",
                    "responseType": ".squareup.roster.mds.BatchGetEmploymentResponse"
                  },
                  "GetEmploymentsForMerchant": {
                    "requestType": ".squareup.roster.mds.GetEmploymentsForMerchantRequest",
                    "responseType": ".squareup.roster.mds.GetEmploymentsForMerchantResponse"
                  },
                  "UpdateEmploymentAppData": {
                    "requestType": ".squareup.roster.mds.UpdateEmploymentAppDataRequest",
                    "responseType": ".squareup.roster.mds.UpdateEmploymentAppDataResponse"
                  },
                  "LookupTokenType": {
                    "requestType": ".squareup.roster.mds.LookupTokenTypeRequest",
                    "responseType": ".squareup.roster.mds.LookupTokenTypeResponse"
                  },
                  "BatchLookupTokenType": {
                    "requestType": ".squareup.roster.mds.BatchLookupTokenTypeRequest",
                    "responseType": ".squareup.roster.mds.BatchLookupTokenTypeResponse"
                  },
                  "GetNumberOfEmployments": {
                    "requestType": ".squareup.roster.mds.GetNumberOfEmploymentsRequest",
                    "responseType": ".squareup.roster.mds.GetNumberOfEmploymentsResponse"
                  },
                  "ListEmploymentsForPos": {
                    "requestType": ".squareup.roster.mds.ListEmploymentsForPosRequest",
                    "responseType": ".squareup.roster.mds.ListEmploymentsForPosResponse"
                  },
                  "ListPermissions": {
                    "requestType": ".squareup.roster.mds.ListPermissionsRequest",
                    "responseType": ".squareup.roster.mds.ListPermissionsResponse"
                  },
                  "FindEmployeeRoles": {
                    "requestType": ".squareup.roster.mds.FindEmployeeRolesRequest",
                    "responseType": ".squareup.roster.mds.FindEmployeeRolesResponse"
                  },
                  "CreateMerchant": {
                    "requestType": ".squareup.roster.mds.CreateMerchantRequest",
                    "responseType": ".squareup.roster.mds.CreateMerchantResponse"
                  },
                  "CreateEmployment": {
                    "requestType": ".squareup.roster.mds.CreateEmploymentRequest",
                    "responseType": ".squareup.roster.mds.CreateEmploymentResponse"
                  },
                  "UpdateEmployment": {
                    "requestType": ".squareup.roster.mds.UpdateEmploymentRequest",
                    "responseType": ".squareup.roster.mds.UpdateEmploymentResponse"
                  },
                  "CreateEmployeeRole": {
                    "requestType": ".squareup.roster.mds.CreateEmployeeRoleRequest",
                    "responseType": ".squareup.roster.mds.CreateEmployeeRoleResponse"
                  },
                  "UpdateEmployeeRole": {
                    "requestType": ".squareup.roster.mds.UpdateEmployeeRoleRequest",
                    "responseType": ".squareup.roster.mds.UpdateEmployeeRoleResponse"
                  },
                  "DeleteEmployeeRole": {
                    "requestType": ".squareup.roster.mds.DeleteEmployeeRoleRequest",
                    "responseType": ".squareup.roster.mds.DeleteEmployeeRoleResponse"
                  },
                  "GetEmploymentsForPerson": {
                    "requestType": ".squareup.roster.mds.GetEmploymentsForPersonRequest",
                    "responseType": ".squareup.roster.mds.GetEmploymentsForPersonResponse"
                  },
                  "ChangeOwner": {
                    "requestType": ".squareup.roster.mds.ChangeOwnerRequest",
                    "responseType": ".squareup.roster.mds.ChangeOwnerResponse"
                  },
                  "BatchGetOwnerPersonToken": {
                    "requestType": ".squareup.roster.mds.BatchGetOwnerPersonTokenRequest",
                    "responseType": ".squareup.roster.mds.BatchGetOwnerPersonTokenResponse"
                  },
                  "GenerateEmploymentPasscode": {
                    "requestType": ".squareup.roster.mds.GenerateEmploymentPasscodeRequest",
                    "responseType": ".squareup.roster.mds.GenerateEmploymentPasscodeResponse"
                  },
                  "UpdateEmploymentPasscode": {
                    "requestType": ".squareup.roster.mds.UpdateEmploymentPasscodeRequest",
                    "responseType": ".squareup.roster.mds.UpdateEmploymentPasscodeResponse"
                  },
                  "ValidateEmploymentPasscode": {
                    "requestType": ".squareup.roster.mds.ValidateEmploymentPasscodeRequest",
                    "responseType": ".squareup.roster.mds.ValidateEmploymentPasscodeResponse"
                  },
                  "UpdateUnitPaymentsPermission": {
                    "requestType": ".squareup.roster.mds.UpdateUnitPaymentsPermissionRequest",
                    "responseType": ".squareup.roster.mds.UpdateUnitPaymentsPermissionResponse"
                  },
                  "BatchGetTokenForId": {
                    "requestType": ".squareup.roster.mds.BatchGetTokenForIdRequest",
                    "responseType": ".squareup.roster.mds.BatchGetTokenForIdResponse"
                  },
                  "ObtainUnitSlug": {
                    "requestType": ".squareup.roster.mds.ObtainUnitSlugRequest",
                    "responseType": ".squareup.roster.mds.ObtainUnitSlugResponse"
                  },
                  "BatchGetOwnerForMerchant": {
                    "requestType": ".squareup.roster.mds.BatchGetOwnerForMerchantRequest",
                    "responseType": ".squareup.roster.mds.BatchGetOwnerForMerchantResponse"
                  },
                  "ReorderUnitPosAdditionalImages": {
                    "requestType": ".squareup.roster.mds.ReorderUnitPosAdditionalImagesRequest",
                    "responseType": ".squareup.roster.mds.ReorderUnitPosAdditionalImagesResponse"
                  },
                  "UpdateMerchantCapabilities": {
                    "requestType": ".squareup.roster.mds.UpdateMerchantCapabilitiesRequest",
                    "responseType": ".squareup.roster.mds.UpdateMerchantCapabilitiesResponse"
                  },
                  "UpdateMerchantTwoFactorState": {
                    "requestType": ".squareup.roster.mds.UpdateMerchantTwoFactorStateRequest",
                    "responseType": ".squareup.roster.mds.UpdateMerchantTwoFactorStateResponse"
                  },
                  "UpdateUnitCapabilities": {
                    "requestType": ".squareup.roster.mds.UpdateUnitCapabilitiesRequest",
                    "responseType": ".squareup.roster.mds.UpdateUnitCapabilitiesResponse"
                  },
                  "GetAuditLogs": {
                    "requestType": ".squareup.roster.mds_audit_log.GetAuditLogsRequest",
                    "responseType": ".squareup.roster.mds_audit_log.GetAuditLogsResponse"
                  },
                  "UpdateUnitBrandData": {
                    "requestType": ".squareup.roster.mds.UpdateUnitBrandDataRequest",
                    "responseType": ".squareup.roster.mds.UpdateUnitBrandDataResponse"
                  },
                  "UpdateUnit": {
                    "requestType": ".squareup.roster.mds.UpdateUnitRequest",
                    "responseType": ".squareup.roster.mds.UpdateUnitResponse"
                  },
                  "UpdateMerchant": {
                    "requestType": ".squareup.roster.mds.UpdateMerchantRequest",
                    "responseType": ".squareup.roster.mds.UpdateMerchantResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Merchant && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Unit && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BusinessUnit && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantProfile && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitInfo && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Employment && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeeRoleAssignment && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeeRoleAssignment?.nested?.MerchantList && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeeRoleAssignment?.nested?.UnitList && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentLite && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeeRole && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeeRole?.nested?.RoleType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeePermissions && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.SecuritySettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantPaymentData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantMultipassData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantLegacyData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantBillingData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantGiftCardsData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantEmSubscriptionData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantAppointmentsData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantMarketingData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantMarketingData?.nested?.EmailReceiptConsentIncentive && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantMarketingData?.nested?.EmailReceiptConsentIncentive?.nested?.DiscountScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantMarketingData?.nested?.EmailReceiptConsentIncentive?.nested?.PercentageOff && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Hours && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Hours?.nested?.Interval && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitHoursData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPaymentData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPaymentData?.nested?.TimedValue && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPaymentData?.nested?.AttributeTimeSeries && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPaymentData?.nested?.Source && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.UKPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.UKPosData?.nested?.VatCustomerClass && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.CAPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.AUPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.FRPosData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosData?.nested?.FRPosData?.nested?.CompanyFormation && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitOnlineStoreData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitBrandData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitSecurityData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitReceiptsData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitLocationData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitLegacyData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UserLegacyData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitBillingData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitActivationData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.CloseOfDayReports && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.EmployeeShiftReports && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.MenuBehaviorSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.MenuBehaviorSettings?.nested?.BehaviorAfterAddingItem && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.ReceiptSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.AutoGratuitySettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.SalesAttributionSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.SalesAttributionSettings?.nested?.TicketOwnerPreference && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.ReopenSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.CourseSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.PreAuthSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.ReservationSettings && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitPosServiceSettingsData?.nested?.ReservationSettings?.nested?.FirstTableTouch && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.LegacyRolloutData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ImagePurposeScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ImagePurposeScope?.nested?.ImagePurpose && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ImageEntry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitBankingData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentMultipassData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmployeePasscode && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentEmployeesData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentLegacyData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentLegacyData?.nested?.SyntheticEmploymentType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentPayrollData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentPayrollData?.nested?.WageType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentInternalData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentInternalData?.nested?.EmploymentType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentInternalData?.nested?.RoleAssignmentInfo && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantCbdData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ContactMethod && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ContactMethod?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ContactMethod?.nested?.ContactType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.PhoneContactMethod && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmailContactMethod && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantCreditData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantCreditData?.nested?.Servicer && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantDeveloperContact && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantDeveloperContactData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantRestaurantsData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantSfsCoreData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantRetailData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantRetailData?.nested?.WebPlatform && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantRetailData?.nested?.MerchantRetailOnboardingData && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.AppDataEntry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.AddressTypeScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.AddressTypeScope?.nested?.AddressType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.AddressEntry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ScriptAddress && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.PaymentFlowPreferences && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ApplicationAllowed && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ApplicationAllowed?.nested?.ApprovalStatus && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnderwritingComplianceFlags && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantCapabilities && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitCapabilities && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BusinessIds && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ScriptScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ScriptScope?.nested?.Script && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Name && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Names && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EntityToken && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ApplicationScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ApplicationScope?.nested?.Application && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FetchFlagScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FetchFlagScope?.nested?.FetchFlag && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.StatusScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.StatusScope?.nested?.Status && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ErrorScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ErrorScope?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Permission && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.Permission?.nested?.PermissionState && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.TokenTypeScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.TokenTypeScope?.nested?.TokenType && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.DecodedAppDataEntry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ProfanityFilteredFieldScope && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ProfanityFilteredFieldScope?.nested?.ProfanityFilteredField && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindMerchantsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindMerchantTokensRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantQuery && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindTokensResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindMerchantsResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.LegacyGetMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetMerchantForPlatformAccountRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetMerchantRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetMerchantResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetUnitsForMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetUnitsForMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindUnitsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindUnitTokensRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UnitQuery && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindUnitsResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetUnitRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetUnitResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetUnitRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetUnitRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetUnitResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetUnitResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantAppDataRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantAppDataResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitAppDataRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitAppDataResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantAddressesRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantAddressesResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantAddressesResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantCapabilitiesRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantCapabilitiesRequest?.nested?.MerchantCapability && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantCapabilitiesResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantTwoFactorStateRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantTwoFactorStateResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitCapabilitiesRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitCapabilitiesRequest?.nested?.UnitCapability && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitCapabilitiesResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmploymentsV2Request && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EgEmploymentFilter && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EgEmploymentSortOrder && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EgEmployeeRoleFilter && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EgLocationFilter && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EgEmployment && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmploymentsV2Response && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmploymentsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmploymentTokensRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentQuery && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmploymentsResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetEmploymentRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetEmploymentRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetEmploymentResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetEmploymentResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetNumberOfEmploymentsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetNumberOfEmploymentsResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentsForMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentsForMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GenerateEmploymentPasscodeRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GenerateEmploymentPasscodeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GenerateEmploymentPasscodeResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentPasscodeRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentPasscodeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentPasscodeResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ValidateEmploymentPasscodeRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ValidateEmploymentPasscodeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ValidateEmploymentPasscodeResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.EmploymentForPos && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ListEmploymentsForPosRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ListEmploymentsForPosRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ListEmploymentsForPosResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentAppDataRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentAppDataResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ListPermissionsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ListPermissionsResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.LookupTokenTypeRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.LookupTokenTypeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchLookupTokenTypeRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchLookupTokenTypeRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchLookupTokenTypeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchLookupTokenTypeResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetTokenForIdRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetTokenForIdRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetTokenForIdResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetTokenForIdResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmployeeRolesRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.FindEmployeeRolesResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateMerchantRequest?.nested?.MerchantCapability && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateMerchantResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentsForPersonRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GetEmploymentsForPersonResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ChangeOwnerRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ChangeOwnerResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ChangeOwnerResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerPersonTokenRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerPersonTokenRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerPersonTokenResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerPersonTokenResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitPaymentsPermissionRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CompleteEmployeeSignupResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CompleteEmployeeSignupResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmploymentResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmploymentResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateEmploymentRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmploymentPayload && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmploymentPayload?.nested?.RemoveField && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateEmploymentResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmploymentResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmployeeRolePayload && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateOrUpdateEmployeeRolePayload?.nested?.ManagedRoles && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateEmployeeRoleRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateEmployeeRoleResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmployeeRoleRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateEmployeeRoleResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.DeleteEmployeeRoleRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateUnitResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.CreateUnitResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.DeactivateMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.DeleteEmployeeRoleResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.DeleteEmployeeRoleResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MigrateMerchantToNativeStorageResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MultiunitUpgradeResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ReactivateMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUserResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUserResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitPaymentsPermissionResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ObtainUnitSlugRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ObtainUnitSlugResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerForMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerForMerchantRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerForMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.BatchGetOwnerForMerchantResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ReorderUnitPosAdditionalImagesRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.ReorderUnitPosAdditionalImagesResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GeocodeUnitRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GeocodeUnitResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.GeocodeUnitResponse?.nested?.Status && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitBrandDataRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitBrandDataRequest?.nested?.RemoveField && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitBrandDataResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitBrandDataResponse?.nested?.Status && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateUnitResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantResponse && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.UpdateMerchantResponse?.nested?.Error && !$root.nested?.squareup?.nested?.roster?.nested?.mds?.nested?.MerchantDataService) {
  $root.addJSON(jsonData);
}

/**
 * An entity that sells things with the Square e-commerce suite.
 *
 * SOURCE Merchant @ squareup/roster/mds.proto at 42:1
 */
export const Merchant = $root.lookupType('squareup.roster.mds.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * A unit, or location, is a place of business for a merchant.
 * A location has a street address, time zone, and preferred language.
 * Payments are taken with respect to a unit.
 *
 * SOURCE Unit @ squareup/roster/mds.proto at 154:1
 */
export const Unit = $root.lookupType('squareup.roster.mds.Unit');
fixType(Unit);
Builder.createAndAttachToType(Unit);
/**
 * BusinessUnit correspond to business units within Block. This can be used to create a different
 * product experience for different BUs, but ideally even when another business unit wants to enable
 * Square processing, we give them a full SQUARE account with their same email address.
 *
 * For now, we have the following restrictions (which might be changed later):
 * * Units have the same BU as their merchant
 * * BUs are immutable
 *
 * SOURCE BusinessUnit @ squareup/roster/mds.proto at 289:1
 */
export const BusinessUnit = $root.lookupEnum('squareup.roster.mds.BusinessUnit').values;
/**
 * Part of the merchant profile for the unit
 *
 * SOURCE MerchantProfile @ squareup/roster/mds.proto at 307:1
 */
export const MerchantProfile = $root.lookupType('squareup.roster.mds.MerchantProfile');
fixType(MerchantProfile);
Builder.createAndAttachToType(MerchantProfile);
/**
 * SOURCE UnitInfo @ squareup/roster/mds.proto at 321:1
 */
export const UnitInfo = $root.lookupType('squareup.roster.mds.UnitInfo');
fixType(UnitInfo);
Builder.createAndAttachToType(UnitInfo);
/**
 * Authorization for an individual person to take actions on behalf of
 * a Square merchant or merchants.
 *
 * SOURCE Employment @ squareup/roster/mds.proto at 337:1
 */
export const Employment = $root.lookupType('squareup.roster.mds.Employment');
fixType(Employment);
Builder.createAndAttachToType(Employment);
/**
 * Authorization to perform actions at some merchants or units.
 *
 * SOURCE EmployeeRoleAssignment @ squareup/roster/mds.proto at 407:1
 */
export const EmployeeRoleAssignment = $root.lookupType('squareup.roster.mds.EmployeeRoleAssignment');
fixType(EmployeeRoleAssignment);
Builder.createAndAttachToType(EmployeeRoleAssignment);
/**
 * Next ID: 10
 *
 * SOURCE MerchantList @ squareup/roster/mds.proto at 442:3
 */
EmployeeRoleAssignment.MerchantList = $root.lookupType('squareup.roster.mds.EmployeeRoleAssignment.MerchantList');
fixType(EmployeeRoleAssignment.MerchantList);
Builder.createAndAttachToType(EmployeeRoleAssignment.MerchantList);
/**
 * SOURCE UnitList @ squareup/roster/mds.proto at 446:3
 */
EmployeeRoleAssignment.UnitList = $root.lookupType('squareup.roster.mds.EmployeeRoleAssignment.UnitList');
fixType(EmployeeRoleAssignment.UnitList);
Builder.createAndAttachToType(EmployeeRoleAssignment.UnitList);
/**
 * SOURCE EmploymentLite @ squareup/roster/mds.proto at 455:1
 */
export const EmploymentLite = $root.lookupType('squareup.roster.mds.EmploymentLite');
fixType(EmploymentLite);
Builder.createAndAttachToType(EmploymentLite);
/**
 * SOURCE EmployeeRole @ squareup/roster/mds.proto at 478:1
 */
export const EmployeeRole = $root.lookupType('squareup.roster.mds.EmployeeRole');
fixType(EmployeeRole);
Builder.createAndAttachToType(EmployeeRole);
/**
 * Enumeration of the kinds of Employee Roles that exist in our system. Aside from the CUSTOM
 * value, each RoleType has predefined semantics related to account ownership, permissions, and
 * billing. Clients are responsible for obeying the proper semantics for each role type.
 *
 * SOURCE RoleType @ squareup/roster/mds.proto at 486:3
 */
EmployeeRole.RoleType = $root.lookupEnum('squareup.roster.mds.EmployeeRole.RoleType').values;
/**
 * The permissions allowed by a given employment record.
 * See employees/employees.proto:EmployeePermissionFlags
 *
 * SOURCE EmployeePermissions @ squareup/roster/mds.proto at 570:1
 */
export const EmployeePermissions = $root.lookupType('squareup.roster.mds.EmployeePermissions');
fixType(EmployeePermissions);
Builder.createAndAttachToType(EmployeePermissions);
/**
 * Security-related policies that can be applied to various entities.
 *
 * SOURCE SecuritySettings @ squareup/roster/mds.proto at 583:1
 */
export const SecuritySettings = $root.lookupType('squareup.roster.mds.SecuritySettings');
fixType(SecuritySettings);
Builder.createAndAttachToType(SecuritySettings);
/**
 * Merchant app data for application=PAYMENTS; vaulted by the Payments team.
 *
 * SOURCE MerchantPaymentData @ squareup/roster/mds.proto at 599:1
 */
export const MerchantPaymentData = $root.lookupType('squareup.roster.mds.MerchantPaymentData');
fixType(MerchantPaymentData);
Builder.createAndAttachToType(MerchantPaymentData);
/**
 * Merchant app data for application=POINT_OF_SALE
 *
 * SOURCE MerchantPosData @ squareup/roster/mds.proto at 613:1
 */
export const MerchantPosData = $root.lookupType('squareup.roster.mds.MerchantPosData');
fixType(MerchantPosData);
Builder.createAndAttachToType(MerchantPosData);
/**
 * Merchant app data for application=MULTIPASS
 *
 * SOURCE MerchantMultipassData @ squareup/roster/mds.proto at 621:1
 */
export const MerchantMultipassData = $root.lookupType('squareup.roster.mds.MerchantMultipassData');
fixType(MerchantMultipassData);
Builder.createAndAttachToType(MerchantMultipassData);
/**
 * Merchant app data for application=LEGACY
 *
 * SOURCE MerchantLegacyData @ squareup/roster/mds.proto at 629:1
 */
export const MerchantLegacyData = $root.lookupType('squareup.roster.mds.MerchantLegacyData');
fixType(MerchantLegacyData);
Builder.createAndAttachToType(MerchantLegacyData);
/**
 * Merchant app data for application=BILLING
 *
 * SOURCE MerchantBillingData @ squareup/roster/mds.proto at 660:1
 */
export const MerchantBillingData = $root.lookupType('squareup.roster.mds.MerchantBillingData');
fixType(MerchantBillingData);
Builder.createAndAttachToType(MerchantBillingData);
/**
 * Merchant app data for application=GIFTCARDS
 *
 * SOURCE MerchantGiftCardsData @ squareup/roster/mds.proto at 668:1
 */
export const MerchantGiftCardsData = $root.lookupType('squareup.roster.mds.MerchantGiftCardsData');
fixType(MerchantGiftCardsData);
Builder.createAndAttachToType(MerchantGiftCardsData);
/**
 * Merchant app data from application=EMPLOYEE_MANAGEMENT_SUBSCRIPTION
 *
 * SOURCE MerchantEmSubscriptionData @ squareup/roster/mds.proto at 679:1
 */
export const MerchantEmSubscriptionData = $root.lookupType('squareup.roster.mds.MerchantEmSubscriptionData');
fixType(MerchantEmSubscriptionData);
Builder.createAndAttachToType(MerchantEmSubscriptionData);
/**
 * Merchant app data from application=APPOINTMENTS
 *
 * SOURCE MerchantAppointmentsData @ squareup/roster/mds.proto at 694:1
 */
export const MerchantAppointmentsData = $root.lookupType('squareup.roster.mds.MerchantAppointmentsData');
fixType(MerchantAppointmentsData);
Builder.createAndAttachToType(MerchantAppointmentsData);
/**
 * Merchant app data from application=MARKETING
 *
 * SOURCE MerchantMarketingData @ squareup/roster/mds.proto at 703:1
 */
export const MerchantMarketingData = $root.lookupType('squareup.roster.mds.MerchantMarketingData');
fixType(MerchantMarketingData);
Builder.createAndAttachToType(MerchantMarketingData);
/**
 * SOURCE EmailReceiptConsentIncentive @ squareup/roster/mds.proto at 710:3
 */
MerchantMarketingData.EmailReceiptConsentIncentive = $root.lookupType('squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive');
fixType(MerchantMarketingData.EmailReceiptConsentIncentive);
Builder.createAndAttachToType(MerchantMarketingData.EmailReceiptConsentIncentive);
/**
 * SOURCE DiscountScope @ squareup/roster/mds.proto at 726:5
 */
MerchantMarketingData.EmailReceiptConsentIncentive.DiscountScope = $root.lookupEnum('squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive.DiscountScope').values;
/**
 * SOURCE PercentageOff @ squareup/roster/mds.proto at 739:5
 */
MerchantMarketingData.EmailReceiptConsentIncentive.PercentageOff = $root.lookupType('squareup.roster.mds.MerchantMarketingData.EmailReceiptConsentIncentive.PercentageOff');
fixType(MerchantMarketingData.EmailReceiptConsentIncentive.PercentageOff);
Builder.createAndAttachToType(MerchantMarketingData.EmailReceiptConsentIncentive.PercentageOff);
/**
 * Deprecated along with its parent, UnitHoursData. Use top-level "NormalBusinessHours" field on Unit instead
 *
 * SOURCE Hours @ squareup/roster/mds.proto at 758:1
 */
export const Hours = $root.lookupType('squareup.roster.mds.Hours');
fixType(Hours);
Builder.createAndAttachToType(Hours);
/**
 * SOURCE Interval @ squareup/roster/mds.proto at 764:3
 */
Hours.Interval = $root.lookupType('squareup.roster.mds.Hours.Interval');
fixType(Hours.Interval);
Builder.createAndAttachToType(Hours.Interval);
/**
 * Deprecated. Use top-level "NormalBusinessHours" field on Unit instead
 * Unit Hours data for application=HOURS.
 *
 * SOURCE UnitHoursData @ squareup/roster/mds.proto at 782:1
 */
export const UnitHoursData = $root.lookupType('squareup.roster.mds.UnitHoursData');
fixType(UnitHoursData);
Builder.createAndAttachToType(UnitHoursData);
/**
 * Unit app data for application=PAYMENTS.
 *
 * SOURCE UnitPaymentData @ squareup/roster/mds.proto at 795:1
 */
export const UnitPaymentData = $root.lookupType('squareup.roster.mds.UnitPaymentData');
fixType(UnitPaymentData);
Builder.createAndAttachToType(UnitPaymentData);
/**
 * Represents the value of an attribute during a particular interval in time.
 *
 * SOURCE TimedValue @ squareup/roster/mds.proto at 798:3
 */
UnitPaymentData.TimedValue = $root.lookupType('squareup.roster.mds.UnitPaymentData.TimedValue');
fixType(UnitPaymentData.TimedValue);
Builder.createAndAttachToType(UnitPaymentData.TimedValue);
/**
 * SOURCE AttributeTimeSeries @ squareup/roster/mds.proto at 804:3
 */
UnitPaymentData.AttributeTimeSeries = $root.lookupType('squareup.roster.mds.UnitPaymentData.AttributeTimeSeries');
fixType(UnitPaymentData.AttributeTimeSeries);
Builder.createAndAttachToType(UnitPaymentData.AttributeTimeSeries);
/**
 * SOURCE Source @ squareup/roster/mds.proto at 809:3
 */
UnitPaymentData.Source = $root.lookupEnum('squareup.roster.mds.UnitPaymentData.Source').values;
/**
 * Unit app data for application=POINT_OF_SALE.
 *
 * SOURCE UnitPosData @ squareup/roster/mds.proto at 868:1
 */
export const UnitPosData = $root.lookupType('squareup.roster.mds.UnitPosData');
fixType(UnitPosData);
Builder.createAndAttachToType(UnitPosData);
/**
 * Next ID: 5
 *
 * SOURCE UKPosData @ squareup/roster/mds.proto at 881:3
 */
UnitPosData.UKPosData = $root.lookupType('squareup.roster.mds.UnitPosData.UKPosData');
fixType(UnitPosData.UKPosData);
Builder.createAndAttachToType(UnitPosData.UKPosData);
/**
 * SOURCE VatCustomerClass @ squareup/roster/mds.proto at 885:5
 */
UnitPosData.UKPosData.VatCustomerClass = $root.lookupEnum('squareup.roster.mds.UnitPosData.UKPosData.VatCustomerClass').values;
/**
 * SOURCE CAPosData @ squareup/roster/mds.proto at 893:3
 */
UnitPosData.CAPosData = $root.lookupType('squareup.roster.mds.UnitPosData.CAPosData');
fixType(UnitPosData.CAPosData);
Builder.createAndAttachToType(UnitPosData.CAPosData);
/**
 * SOURCE AUPosData @ squareup/roster/mds.proto at 900:3
 */
UnitPosData.AUPosData = $root.lookupType('squareup.roster.mds.UnitPosData.AUPosData');
fixType(UnitPosData.AUPosData);
Builder.createAndAttachToType(UnitPosData.AUPosData);
/**
 * Deprecated. Use the fields in BusinessIds instead.
 *
 * SOURCE FRPosData @ squareup/roster/mds.proto at 909:3
 */
UnitPosData.FRPosData = $root.lookupType('squareup.roster.mds.UnitPosData.FRPosData');
fixType(UnitPosData.FRPosData);
Builder.createAndAttachToType(UnitPosData.FRPosData);
/**
 * SOURCE CompanyFormation @ squareup/roster/mds.proto at 939:5
 */
UnitPosData.FRPosData.CompanyFormation = $root.lookupEnum('squareup.roster.mds.UnitPosData.FRPosData.CompanyFormation').values;
/**
 * SOURCE UnitOnlineStoreData @ squareup/roster/mds.proto at 959:1
 */
export const UnitOnlineStoreData = $root.lookupType('squareup.roster.mds.UnitOnlineStoreData');
fixType(UnitOnlineStoreData);
Builder.createAndAttachToType(UnitOnlineStoreData);
/**
 * Unit app data for application=BRAND.
 *
 * SOURCE UnitBrandData @ squareup/roster/mds.proto at 990:1
 */
export const UnitBrandData = $root.lookupType('squareup.roster.mds.UnitBrandData');
fixType(UnitBrandData);
Builder.createAndAttachToType(UnitBrandData);
/**
 * Unit app data for application=SECURITY.
 *
 * SOURCE UnitSecurityData @ squareup/roster/mds.proto at 1026:1
 */
export const UnitSecurityData = $root.lookupType('squareup.roster.mds.UnitSecurityData');
fixType(UnitSecurityData);
Builder.createAndAttachToType(UnitSecurityData);
/**
 * Unit app data for application=RECEIPTS.
 *
 * SOURCE UnitReceiptsData @ squareup/roster/mds.proto at 1034:1
 */
export const UnitReceiptsData = $root.lookupType('squareup.roster.mds.UnitReceiptsData');
fixType(UnitReceiptsData);
Builder.createAndAttachToType(UnitReceiptsData);
/**
 * Unit app data for application=LOCATION. This includes information about
 * the physical location of a unit.
 *
 * SOURCE UnitLocationData @ squareup/roster/mds.proto at 1067:1
 */
export const UnitLocationData = $root.lookupType('squareup.roster.mds.UnitLocationData');
fixType(UnitLocationData);
Builder.createAndAttachToType(UnitLocationData);
/**
 * Unit app data for application=LEGACY
 *
 * SOURCE UnitLegacyData @ squareup/roster/mds.proto at 1085:1
 */
export const UnitLegacyData = $root.lookupType('squareup.roster.mds.UnitLegacyData');
fixType(UnitLegacyData);
Builder.createAndAttachToType(UnitLegacyData);
/**
 * Common legacy data from the old SqWeb database that is available for both units and merchants.
 *
 * SOURCE UserLegacyData @ squareup/roster/mds.proto at 1098:1
 */
export const UserLegacyData = $root.lookupType('squareup.roster.mds.UserLegacyData');
fixType(UserLegacyData);
Builder.createAndAttachToType(UserLegacyData);
/**
 * Unit app data for application=BILLING
 *
 * SOURCE UnitBillingData @ squareup/roster/mds.proto at 1142:1
 */
export const UnitBillingData = $root.lookupType('squareup.roster.mds.UnitBillingData');
fixType(UnitBillingData);
Builder.createAndAttachToType(UnitBillingData);
/**
 * Unit app data for application=ACTIVATION
 * Fields are derived from the immutable ActivationRequest that is defined at account activation time.
 * Only a subset of fields are included that are only derivable from the activation details.
 *
 * SOURCE UnitActivationData @ squareup/roster/mds.proto at 1152:1
 */
export const UnitActivationData = $root.lookupType('squareup.roster.mds.UnitActivationData');
fixType(UnitActivationData);
Builder.createAndAttachToType(UnitActivationData);
/**
 * Unit app data for application=POS_SERVICE_SETTINGS
 *
 * SOURCE UnitPosServiceSettingsData @ squareup/roster/mds.proto at 1188:1
 */
export const UnitPosServiceSettingsData = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData');
fixType(UnitPosServiceSettingsData);
Builder.createAndAttachToType(UnitPosServiceSettingsData);
/**
 * Service settings regarding close of day reports (the reports run by a manager at the end of the day.)
 *
 * SOURCE CloseOfDayReports @ squareup/roster/mds.proto at 1191:3
 */
UnitPosServiceSettingsData.CloseOfDayReports = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.CloseOfDayReports');
fixType(UnitPosServiceSettingsData.CloseOfDayReports);
Builder.createAndAttachToType(UnitPosServiceSettingsData.CloseOfDayReports);
/**
 * Service settings regarding employee shift reports (the reports run by an employee at the end of their shift.)
 *
 * SOURCE EmployeeShiftReports @ squareup/roster/mds.proto at 1222:3
 */
UnitPosServiceSettingsData.EmployeeShiftReports = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.EmployeeShiftReports');
fixType(UnitPosServiceSettingsData.EmployeeShiftReports);
Builder.createAndAttachToType(UnitPosServiceSettingsData.EmployeeShiftReports);
/**
 * Service Settings regard menu behavior for RST merchants
 *
 * SOURCE MenuBehaviorSettings @ squareup/roster/mds.proto at 1253:3
 */
UnitPosServiceSettingsData.MenuBehaviorSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.MenuBehaviorSettings');
fixType(UnitPosServiceSettingsData.MenuBehaviorSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.MenuBehaviorSettings);
/**
 * SOURCE BehaviorAfterAddingItem @ squareup/roster/mds.proto at 1254:5
 */
UnitPosServiceSettingsData.MenuBehaviorSettings.BehaviorAfterAddingItem = $root.lookupEnum('squareup.roster.mds.UnitPosServiceSettingsData.MenuBehaviorSettings.BehaviorAfterAddingItem').values;
/**
 * SOURCE ReceiptSettings @ squareup/roster/mds.proto at 1267:3
 */
UnitPosServiceSettingsData.ReceiptSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.ReceiptSettings');
fixType(UnitPosServiceSettingsData.ReceiptSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.ReceiptSettings);
/**
 * Service Settings regarding whether or not to enable auto-gratuity surcharges for the location.
 *
 * SOURCE AutoGratuitySettings @ squareup/roster/mds.proto at 1279:3
 */
UnitPosServiceSettingsData.AutoGratuitySettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.AutoGratuitySettings');
fixType(UnitPosServiceSettingsData.AutoGratuitySettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.AutoGratuitySettings);
/**
 * SOURCE SalesAttributionSettings @ squareup/roster/mds.proto at 1286:3
 */
UnitPosServiceSettingsData.SalesAttributionSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.SalesAttributionSettings');
fixType(UnitPosServiceSettingsData.SalesAttributionSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.SalesAttributionSettings);
/**
 * SOURCE TicketOwnerPreference @ squareup/roster/mds.proto at 1287:5
 */
UnitPosServiceSettingsData.SalesAttributionSettings.TicketOwnerPreference = $root.lookupEnum('squareup.roster.mds.UnitPosServiceSettingsData.SalesAttributionSettings.TicketOwnerPreference').values;
/**
 * Service Settings regarding whether or not to enable reopening and updating checks
 * via the AmendCompletingBill endpoint.
 * Design: https://docs.google.com/document/d/1BXA9e2B9FXDj2iotZRrMRVmE1VQ6NHDl9-zZKn_CwM8/edit
 *
 * SOURCE ReopenSettings @ squareup/roster/mds.proto at 1303:3
 */
UnitPosServiceSettingsData.ReopenSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.ReopenSettings');
fixType(UnitPosServiceSettingsData.ReopenSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.ReopenSettings);
/**
 * SOURCE CourseSettings @ squareup/roster/mds.proto at 1311:3
 */
UnitPosServiceSettingsData.CourseSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.CourseSettings');
fixType(UnitPosServiceSettingsData.CourseSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.CourseSettings);
/**
 * SOURCE PreAuthSettings @ squareup/roster/mds.proto at 1319:3
 */
UnitPosServiceSettingsData.PreAuthSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.PreAuthSettings');
fixType(UnitPosServiceSettingsData.PreAuthSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.PreAuthSettings);
/**
 * SOURCE ReservationSettings @ squareup/roster/mds.proto at 1326:3
 */
UnitPosServiceSettingsData.ReservationSettings = $root.lookupType('squareup.roster.mds.UnitPosServiceSettingsData.ReservationSettings');
fixType(UnitPosServiceSettingsData.ReservationSettings);
Builder.createAndAttachToType(UnitPosServiceSettingsData.ReservationSettings);
/**
 * Controls the Restaurants First Table Touch Service Setting.
 * Design: https://docs.google.com/document/d/1Z512Jg6YvgWpknWbi_Uopn6-_nqH8cXJK9wyPMbSMbc/edit
 *
 * SOURCE FirstTableTouch @ squareup/roster/mds.proto at 1329:5
 */
UnitPosServiceSettingsData.ReservationSettings.FirstTableTouch = $root.lookupEnum('squareup.roster.mds.UnitPosServiceSettingsData.ReservationSettings.FirstTableTouch').values;
/**
 * App data for application=LEGACY_DATA.
 * These represent rollout flags that can be included for Merchants, Units, and Employments.
 *
 * SOURCE LegacyRolloutData @ squareup/roster/mds.proto at 1356:1
 */
export const LegacyRolloutData = $root.lookupType('squareup.roster.mds.LegacyRolloutData');
fixType(LegacyRolloutData);
Builder.createAndAttachToType(LegacyRolloutData);
/**
 * SOURCE ImagePurposeScope @ squareup/roster/mds.proto at 1382:1
 */
export const ImagePurposeScope = $root.lookupType('squareup.roster.mds.ImagePurposeScope');
fixType(ImagePurposeScope);
Builder.createAndAttachToType(ImagePurposeScope);
/**
 * The purpose of an image.
 *
 * SOURCE ImagePurpose @ squareup/roster/mds.proto at 1384:3
 */
ImagePurposeScope.ImagePurpose = $root.lookupEnum('squareup.roster.mds.ImagePurposeScope.ImagePurpose').values;
/**
 * SOURCE ImageEntry @ squareup/roster/mds.proto at 1415:1
 */
export const ImageEntry = $root.lookupType('squareup.roster.mds.ImageEntry');
fixType(ImageEntry);
Builder.createAndAttachToType(ImageEntry);
/**
 * App data for application=BANKING
 *
 * SOURCE UnitBankingData @ squareup/roster/mds.proto at 1447:1
 */
export const UnitBankingData = $root.lookupType('squareup.roster.mds.UnitBankingData');
fixType(UnitBankingData);
Builder.createAndAttachToType(UnitBankingData);
/**
 * -- Employment app data
 * Employment app data for application=MULTIPASS
 *
 * SOURCE EmploymentMultipassData @ squareup/roster/mds.proto at 1455:1
 */
export const EmploymentMultipassData = $root.lookupType('squareup.roster.mds.EmploymentMultipassData');
fixType(EmploymentMultipassData);
Builder.createAndAttachToType(EmploymentMultipassData);
/**
 * SOURCE EmployeePasscode @ squareup/roster/mds.proto at 1470:1
 */
export const EmployeePasscode = $root.lookupType('squareup.roster.mds.EmployeePasscode');
fixType(EmployeePasscode);
Builder.createAndAttachToType(EmployeePasscode);
/**
 * Employment app data for application=EMPLOYEES
 *
 * SOURCE EmploymentEmployeesData @ squareup/roster/mds.proto at 1492:1
 */
export const EmploymentEmployeesData = $root.lookupType('squareup.roster.mds.EmploymentEmployeesData');
fixType(EmploymentEmployeesData);
Builder.createAndAttachToType(EmploymentEmployeesData);
/**
 * Employment app data for application=LEGACY
 *
 * SOURCE EmploymentLegacyData @ squareup/roster/mds.proto at 1497:1
 */
export const EmploymentLegacyData = $root.lookupType('squareup.roster.mds.EmploymentLegacyData');
fixType(EmploymentLegacyData);
Builder.createAndAttachToType(EmploymentLegacyData);
/**
 * SOURCE SyntheticEmploymentType @ squareup/roster/mds.proto at 1524:3
 */
EmploymentLegacyData.SyntheticEmploymentType = $root.lookupEnum('squareup.roster.mds.EmploymentLegacyData.SyntheticEmploymentType').values;
/**
 * Employment app data for application=PAYROLL
 * DEPRECATED: this is being moved to the employeejobs service
 * Contact the #employee-management slack channel if you need to use this proto
 *
 * SOURCE EmploymentPayrollData @ squareup/roster/mds.proto at 1540:1
 */
export const EmploymentPayrollData = $root.lookupType('squareup.roster.mds.EmploymentPayrollData');
fixType(EmploymentPayrollData);
Builder.createAndAttachToType(EmploymentPayrollData);
/**
 * SOURCE WageType @ squareup/roster/mds.proto at 1549:3
 */
EmploymentPayrollData.WageType = $root.lookupEnum('squareup.roster.mds.EmploymentPayrollData.WageType').values;
/**
 * Employment app data for application=INTERNAL
 *
 * SOURCE EmploymentInternalData @ squareup/roster/mds.proto at 1564:1
 */
export const EmploymentInternalData = $root.lookupType('squareup.roster.mds.EmploymentInternalData');
fixType(EmploymentInternalData);
Builder.createAndAttachToType(EmploymentInternalData);
/**
 * SOURCE EmploymentType @ squareup/roster/mds.proto at 1565:3
 */
EmploymentInternalData.EmploymentType = $root.lookupEnum('squareup.roster.mds.EmploymentInternalData.EmploymentType').values;
/**
 * SOURCE RoleAssignmentInfo @ squareup/roster/mds.proto at 1573:3
 */
EmploymentInternalData.RoleAssignmentInfo = $root.lookupType('squareup.roster.mds.EmploymentInternalData.RoleAssignmentInfo');
fixType(EmploymentInternalData.RoleAssignmentInfo);
Builder.createAndAttachToType(EmploymentInternalData.RoleAssignmentInfo);
/**
 * Merchant app data for application=CBD.
 *
 * SOURCE MerchantCbdData @ squareup/roster/mds.proto at 1632:1
 */
export const MerchantCbdData = $root.lookupType('squareup.roster.mds.MerchantCbdData');
fixType(MerchantCbdData);
Builder.createAndAttachToType(MerchantCbdData);
/**
 * A method of contacting someone. These are used for units, merchants, and employments.
 *
 * SOURCE ContactMethod @ squareup/roster/mds.proto at 1637:1
 */
export const ContactMethod = $root.lookupType('squareup.roster.mds.ContactMethod');
fixType(ContactMethod);
Builder.createAndAttachToType(ContactMethod);
/**
 * Next ID: 6
 *
 * SOURCE VerificationStatus @ squareup/roster/mds.proto at 1649:3
 */
ContactMethod.VerificationStatus = $root.lookupEnum('squareup.roster.mds.ContactMethod.VerificationStatus').values;
/**
 * SOURCE ContactType @ squareup/roster/mds.proto at 1656:3
 */
ContactMethod.ContactType = $root.lookupEnum('squareup.roster.mds.ContactMethod.ContactType').values;
/**
 * A phone number intended for use as a contact method.
 *
 * SOURCE PhoneContactMethod @ squareup/roster/mds.proto at 1677:1
 */
export const PhoneContactMethod = $root.lookupType('squareup.roster.mds.PhoneContactMethod');
fixType(PhoneContactMethod);
Builder.createAndAttachToType(PhoneContactMethod);
/**
 * An email intended for use as a contact method.
 *
 * SOURCE EmailContactMethod @ squareup/roster/mds.proto at 1684:1
 */
export const EmailContactMethod = $root.lookupType('squareup.roster.mds.EmailContactMethod');
fixType(EmailContactMethod);
Builder.createAndAttachToType(EmailContactMethod);
/**
 * SOURCE MerchantCreditData @ squareup/roster/mds.proto at 1690:1
 */
export const MerchantCreditData = $root.lookupType('squareup.roster.mds.MerchantCreditData');
fixType(MerchantCreditData);
Builder.createAndAttachToType(MerchantCreditData);
/**
 * Next ID: 4
 *
 * SOURCE Servicer @ squareup/roster/mds.proto at 1704:3
 */
MerchantCreditData.Servicer = $root.lookupEnum('squareup.roster.mds.MerchantCreditData.Servicer').values;
/**
 * A single developer contact for sending developer-centric updates to.
 *
 * SOURCE MerchantDeveloperContact @ squareup/roster/mds.proto at 1712:1
 */
export const MerchantDeveloperContact = $root.lookupType('squareup.roster.mds.MerchantDeveloperContact');
fixType(MerchantDeveloperContact);
Builder.createAndAttachToType(MerchantDeveloperContact);
/**
 * A collection of 1-3 developer contacts for sending developer-centric updates to.
 * The 3-contact cap is enforced by the owner app (`connect-web`).
 *
 * SOURCE MerchantDeveloperContactData @ squareup/roster/mds.proto at 1729:1
 */
export const MerchantDeveloperContactData = $root.lookupType('squareup.roster.mds.MerchantDeveloperContactData');
fixType(MerchantDeveloperContactData);
Builder.createAndAttachToType(MerchantDeveloperContactData);
/**
 * SOURCE MerchantRestaurantsData @ squareup/roster/mds.proto at 1739:1
 */
export const MerchantRestaurantsData = $root.lookupType('squareup.roster.mds.MerchantRestaurantsData');
fixType(MerchantRestaurantsData);
Builder.createAndAttachToType(MerchantRestaurantsData);
/**
 * SOURCE MerchantSfsCoreData @ squareup/roster/mds.proto at 1746:1
 */
export const MerchantSfsCoreData = $root.lookupType('squareup.roster.mds.MerchantSfsCoreData');
fixType(MerchantSfsCoreData);
Builder.createAndAttachToType(MerchantSfsCoreData);
/**
 * SOURCE MerchantRetailData @ squareup/roster/mds.proto at 1756:1
 */
export const MerchantRetailData = $root.lookupType('squareup.roster.mds.MerchantRetailData');
fixType(MerchantRetailData);
Builder.createAndAttachToType(MerchantRetailData);
/**
 * A website or e-commerce site platform.
 *
 * SOURCE WebPlatform @ squareup/roster/mds.proto at 1758:3
 */
MerchantRetailData.WebPlatform = $root.lookupEnum('squareup.roster.mds.MerchantRetailData.WebPlatform').values;
/**
 * Seller's Retail onboarding data.
 *
 * SOURCE MerchantRetailOnboardingData @ squareup/roster/mds.proto at 1764:3
 */
MerchantRetailData.MerchantRetailOnboardingData = $root.lookupType('squareup.roster.mds.MerchantRetailData.MerchantRetailOnboardingData');
fixType(MerchantRetailData.MerchantRetailOnboardingData);
Builder.createAndAttachToType(MerchantRetailData.MerchantRetailOnboardingData);
/**
 * The "app data" for a given application. Roster stores app data on
 * all of its entities on behalf of other applications. There is a separate
 * AppDataEntry for each application type. The associated app data is in
 * a binary field that can be of any format the application chooses.
 *
 * SOURCE AppDataEntry @ squareup/roster/mds.proto at 1778:1
 */
export const AppDataEntry = $root.lookupType('squareup.roster.mds.AppDataEntry');
fixType(AppDataEntry);
Builder.createAndAttachToType(AppDataEntry);
/**
 * SOURCE AddressTypeScope @ squareup/roster/mds.proto at 1792:1
 */
export const AddressTypeScope = $root.lookupType('squareup.roster.mds.AddressTypeScope');
fixType(AddressTypeScope);
Builder.createAndAttachToType(AddressTypeScope);
/**
 * SOURCE AddressType @ squareup/roster/mds.proto at 1793:3
 */
AddressTypeScope.AddressType = $root.lookupEnum('squareup.roster.mds.AddressTypeScope.AddressType').values;
/**
 * An extended address record. It includes a GlobalAddress along with
 * additional information that is relevant in the context of an MDS entity.
 *
 * SOURCE AddressEntry @ squareup/roster/mds.proto at 1818:1
 */
export const AddressEntry = $root.lookupType('squareup.roster.mds.AddressEntry');
fixType(AddressEntry);
Builder.createAndAttachToType(AddressEntry);
/**
 * SOURCE ScriptAddress @ squareup/roster/mds.proto at 1866:1
 */
export const ScriptAddress = $root.lookupType('squareup.roster.mds.ScriptAddress');
fixType(ScriptAddress);
Builder.createAndAttachToType(ScriptAddress);
/**
 * SOURCE PaymentFlowPreferences @ squareup/roster/mds.proto at 1875:1
 */
export const PaymentFlowPreferences = $root.lookupType('squareup.roster.mds.PaymentFlowPreferences');
fixType(PaymentFlowPreferences);
Builder.createAndAttachToType(PaymentFlowPreferences);
/**
 * SOURCE ApplicationAllowed @ squareup/roster/mds.proto at 1879:1
 */
export const ApplicationAllowed = $root.lookupType('squareup.roster.mds.ApplicationAllowed');
fixType(ApplicationAllowed);
Builder.createAndAttachToType(ApplicationAllowed);
/**
 * SOURCE ApprovalStatus @ squareup/roster/mds.proto at 1880:3
 */
ApplicationAllowed.ApprovalStatus = $root.lookupEnum('squareup.roster.mds.ApplicationAllowed.ApprovalStatus').values;
/**
 * On/off flags that have been subsumed by capabilities. New code should use
 * capabilities, instead. See MerchantCapabilities and UnitCapabilities.
 *
 * This protobuf was originally intended to record the underwriting state of a
 * merchant or unit, but over time people added on/off flags that have no obvious
 * commonality to them.
 *
 * SOURCE UnderwritingComplianceFlags @ squareup/roster/mds.proto at 1911:1
 */
export const UnderwritingComplianceFlags = $root.lookupType('squareup.roster.mds.UnderwritingComplianceFlags');
fixType(UnderwritingComplianceFlags);
Builder.createAndAttachToType(UnderwritingComplianceFlags);
/**
 * The Square features that can be enabled for the merchant.
 *
 * SOURCE MerchantCapabilities @ squareup/roster/mds.proto at 1957:1
 */
export const MerchantCapabilities = $root.lookupType('squareup.roster.mds.MerchantCapabilities');
fixType(MerchantCapabilities);
Builder.createAndAttachToType(MerchantCapabilities);
/**
 * The Square features that can be enabled for a unit.
 *
 * SOURCE UnitCapabilities @ squareup/roster/mds.proto at 2091:1
 */
export const UnitCapabilities = $root.lookupType('squareup.roster.mds.UnitCapabilities');
fixType(UnitCapabilities);
Builder.createAndAttachToType(UnitCapabilities);
/**
 * SOURCE BusinessIds @ squareup/roster/mds.proto at 2162:1
 */
export const BusinessIds = $root.lookupType('squareup.roster.mds.BusinessIds');
fixType(BusinessIds);
Builder.createAndAttachToType(BusinessIds);
/**
 * An artificial scoping wrapper so that elements of the Script enum will
 * not get generated into the top level namespace.
 *
 * SOURCE ScriptScope @ squareup/roster/mds.proto at 2226:1
 */
export const ScriptScope = $root.lookupType('squareup.roster.mds.ScriptScope');
fixType(ScriptScope);
Builder.createAndAttachToType(ScriptScope);
/**
 * A script that can be used to write a name. These come from
 * ISO15924 (http://unicode.org/iso15924/iso15924-codes.html).
 *
 * SOURCE Script @ squareup/roster/mds.proto at 2229:3
 */
ScriptScope.Script = $root.lookupEnum('squareup.roster.mds.ScriptScope.Script').values;
/**
 * SOURCE Name @ squareup/roster/mds.proto at 2292:1
 */
export const Name = $root.lookupType('squareup.roster.mds.Name');
fixType(Name);
Builder.createAndAttachToType(Name);
/**
 * SOURCE Names @ squareup/roster/mds.proto at 2305:1
 */
export const Names = $root.lookupType('squareup.roster.mds.Names');
fixType(Names);
Builder.createAndAttachToType(Names);
/**
 * SOURCE EntityToken @ squareup/roster/mds.proto at 2319:1
 */
export const EntityToken = $root.lookupType('squareup.roster.mds.EntityToken');
fixType(EntityToken);
Builder.createAndAttachToType(EntityToken);
/**
 * SOURCE ApplicationScope @ squareup/roster/mds.proto at 2335:1
 */
export const ApplicationScope = $root.lookupType('squareup.roster.mds.ApplicationScope');
fixType(ApplicationScope);
Builder.createAndAttachToType(ApplicationScope);
/**
 * An application that can attach app data to a Roster entity.
 *
 * SOURCE Application @ squareup/roster/mds.proto at 2337:3
 */
ApplicationScope.Application = $root.lookupEnum('squareup.roster.mds.ApplicationScope.Application').values;
/**
 * SOURCE FetchFlagScope @ squareup/roster/mds.proto at 2511:1
 */
export const FetchFlagScope = $root.lookupType('squareup.roster.mds.FetchFlagScope');
fixType(FetchFlagScope);
Builder.createAndAttachToType(FetchFlagScope);
/**
 * Flags that specify additional information to include in the returned result.
 *
 * SOURCE FetchFlag @ squareup/roster/mds.proto at 2513:3
 */
FetchFlagScope.FetchFlag = $root.lookupEnum('squareup.roster.mds.FetchFlagScope.FetchFlag').values;
/**
 * SOURCE StatusScope @ squareup/roster/mds.proto at 2566:1
 */
export const StatusScope = $root.lookupType('squareup.roster.mds.StatusScope');
fixType(StatusScope);
Builder.createAndAttachToType(StatusScope);
/**
 * SOURCE Status @ squareup/roster/mds.proto at 2567:3
 */
StatusScope.Status = $root.lookupEnum('squareup.roster.mds.StatusScope.Status').values;
/**
 * SOURCE ErrorScope @ squareup/roster/mds.proto at 2574:1
 */
export const ErrorScope = $root.lookupType('squareup.roster.mds.ErrorScope');
fixType(ErrorScope);
Builder.createAndAttachToType(ErrorScope);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 2575:3
 */
ErrorScope.Error = $root.lookupEnum('squareup.roster.mds.ErrorScope.Error').values;
/**
 * A permission in the permissions table
 *
 * SOURCE Permission @ squareup/roster/mds.proto at 2594:1
 */
export const Permission = $root.lookupType('squareup.roster.mds.Permission');
fixType(Permission);
Builder.createAndAttachToType(Permission);
/**
 * SOURCE PermissionState @ squareup/roster/mds.proto at 2595:3
 */
Permission.PermissionState = $root.lookupEnum('squareup.roster.mds.Permission.PermissionState').values;
/**
 * SOURCE TokenTypeScope @ squareup/roster/mds.proto at 2615:1
 */
export const TokenTypeScope = $root.lookupType('squareup.roster.mds.TokenTypeScope');
fixType(TokenTypeScope);
Builder.createAndAttachToType(TokenTypeScope);
/**
 * A type of token that can be passed to MerchantDataService
 *
 * SOURCE TokenType @ squareup/roster/mds.proto at 2617:3
 */
TokenTypeScope.TokenType = $root.lookupEnum('squareup.roster.mds.TokenTypeScope.TokenType').values;
/**
 * MDS application data in its protobuf format. This is used to display app data in a human-readable
 * format in the admin console.
 *
 * SOURCE DecodedAppDataEntry @ squareup/roster/mds.proto at 2629:1
 */
export const DecodedAppDataEntry = $root.lookupType('squareup.roster.mds.DecodedAppDataEntry');
fixType(DecodedAppDataEntry);
Builder.createAndAttachToType(DecodedAppDataEntry);
/**
 * SOURCE ProfanityFilteredFieldScope @ squareup/roster/mds.proto at 2681:1
 */
export const ProfanityFilteredFieldScope = $root.lookupType('squareup.roster.mds.ProfanityFilteredFieldScope');
fixType(ProfanityFilteredFieldScope);
Builder.createAndAttachToType(ProfanityFilteredFieldScope);
/**
 * SOURCE ProfanityFilteredField @ squareup/roster/mds.proto at 2682:3
 */
ProfanityFilteredFieldScope.ProfanityFilteredField = $root.lookupEnum('squareup.roster.mds.ProfanityFilteredFieldScope.ProfanityFilteredField').values;
/**
 * SOURCE FindMerchantsRequest @ squareup/roster/mds.proto at 2728:1
 */
export const FindMerchantsRequest = $root.lookupType('squareup.roster.mds.FindMerchantsRequest');
fixType(FindMerchantsRequest);
Builder.createAndAttachToType(FindMerchantsRequest);
/**
 * SOURCE FindMerchantTokensRequest @ squareup/roster/mds.proto at 2746:1
 */
export const FindMerchantTokensRequest = $root.lookupType('squareup.roster.mds.FindMerchantTokensRequest');
fixType(FindMerchantTokensRequest);
Builder.createAndAttachToType(FindMerchantTokensRequest);
/**
 * SOURCE MerchantQuery @ squareup/roster/mds.proto at 2757:1
 */
export const MerchantQuery = $root.lookupType('squareup.roster.mds.MerchantQuery');
fixType(MerchantQuery);
Builder.createAndAttachToType(MerchantQuery);
/**
 * SOURCE FindTokensResponse @ squareup/roster/mds.proto at 2763:1
 */
export const FindTokensResponse = $root.lookupType('squareup.roster.mds.FindTokensResponse');
fixType(FindTokensResponse);
Builder.createAndAttachToType(FindTokensResponse);
/**
 * SOURCE FindMerchantsResponse @ squareup/roster/mds.proto at 2772:1
 */
export const FindMerchantsResponse = $root.lookupType('squareup.roster.mds.FindMerchantsResponse');
fixType(FindMerchantsResponse);
Builder.createAndAttachToType(FindMerchantsResponse);
/**
 * SOURCE GetMerchantRequest @ squareup/roster/mds.proto at 2781:1
 */
export const GetMerchantRequest = $root.lookupType('squareup.roster.mds.GetMerchantRequest');
fixType(GetMerchantRequest);
Builder.createAndAttachToType(GetMerchantRequest);
/**
 * SOURCE GetMerchantResponse @ squareup/roster/mds.proto at 2793:1
 */
export const GetMerchantResponse = $root.lookupType('squareup.roster.mds.GetMerchantResponse');
fixType(GetMerchantResponse);
Builder.createAndAttachToType(GetMerchantResponse);
/**
 * Note: This interface is transitional - if you use it, you
 * should plan on removing it in the intermediate future.
 *
 * SOURCE LegacyGetMerchantRequest @ squareup/roster/mds.proto at 2800:1
 */
export const LegacyGetMerchantRequest = $root.lookupType('squareup.roster.mds.LegacyGetMerchantRequest');
fixType(LegacyGetMerchantRequest);
Builder.createAndAttachToType(LegacyGetMerchantRequest);
/**
 * SOURCE GetMerchantForPlatformAccountRequest @ squareup/roster/mds.proto at 2813:1
 */
export const GetMerchantForPlatformAccountRequest = $root.lookupType('squareup.roster.mds.GetMerchantForPlatformAccountRequest');
fixType(GetMerchantForPlatformAccountRequest);
Builder.createAndAttachToType(GetMerchantForPlatformAccountRequest);
/**
 * SOURCE BatchGetMerchantRequest @ squareup/roster/mds.proto at 2827:1
 */
export const BatchGetMerchantRequest = $root.lookupType('squareup.roster.mds.BatchGetMerchantRequest');
fixType(BatchGetMerchantRequest);
Builder.createAndAttachToType(BatchGetMerchantRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 2828:3
 */
BatchGetMerchantRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetMerchantRequest.Constants').values;
/**
 * SOURCE BatchGetMerchantResponse @ squareup/roster/mds.proto at 2842:1
 */
export const BatchGetMerchantResponse = $root.lookupType('squareup.roster.mds.BatchGetMerchantResponse');
fixType(BatchGetMerchantResponse);
Builder.createAndAttachToType(BatchGetMerchantResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 2843:3
 */
BatchGetMerchantResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetMerchantResponse.Entry');
fixType(BatchGetMerchantResponse.Entry);
Builder.createAndAttachToType(BatchGetMerchantResponse.Entry);
/**
 * SOURCE GetUnitsForMerchantRequest @ squareup/roster/mds.proto at 2854:1
 */
export const GetUnitsForMerchantRequest = $root.lookupType('squareup.roster.mds.GetUnitsForMerchantRequest');
fixType(GetUnitsForMerchantRequest);
Builder.createAndAttachToType(GetUnitsForMerchantRequest);
/**
 * SOURCE GetUnitsForMerchantResponse @ squareup/roster/mds.proto at 2863:1
 */
export const GetUnitsForMerchantResponse = $root.lookupType('squareup.roster.mds.GetUnitsForMerchantResponse');
fixType(GetUnitsForMerchantResponse);
Builder.createAndAttachToType(GetUnitsForMerchantResponse);
/**
 * SOURCE FindUnitsRequest @ squareup/roster/mds.proto at 2868:1
 */
export const FindUnitsRequest = $root.lookupType('squareup.roster.mds.FindUnitsRequest');
fixType(FindUnitsRequest);
Builder.createAndAttachToType(FindUnitsRequest);
/**
 * SOURCE FindUnitTokensRequest @ squareup/roster/mds.proto at 2885:1
 */
export const FindUnitTokensRequest = $root.lookupType('squareup.roster.mds.FindUnitTokensRequest');
fixType(FindUnitTokensRequest);
Builder.createAndAttachToType(FindUnitTokensRequest);
/**
 * SOURCE UnitQuery @ squareup/roster/mds.proto at 2896:1
 */
export const UnitQuery = $root.lookupType('squareup.roster.mds.UnitQuery');
fixType(UnitQuery);
Builder.createAndAttachToType(UnitQuery);
/**
 * SOURCE FindUnitsResponse @ squareup/roster/mds.proto at 2916:1
 */
export const FindUnitsResponse = $root.lookupType('squareup.roster.mds.FindUnitsResponse');
fixType(FindUnitsResponse);
Builder.createAndAttachToType(FindUnitsResponse);
/**
 * SOURCE GetUnitRequest @ squareup/roster/mds.proto at 2925:1
 */
export const GetUnitRequest = $root.lookupType('squareup.roster.mds.GetUnitRequest');
fixType(GetUnitRequest);
Builder.createAndAttachToType(GetUnitRequest);
/**
 * SOURCE GetUnitResponse @ squareup/roster/mds.proto at 2936:1
 */
export const GetUnitResponse = $root.lookupType('squareup.roster.mds.GetUnitResponse');
fixType(GetUnitResponse);
Builder.createAndAttachToType(GetUnitResponse);
/**
 * SOURCE BatchGetUnitRequest @ squareup/roster/mds.proto at 2941:1
 */
export const BatchGetUnitRequest = $root.lookupType('squareup.roster.mds.BatchGetUnitRequest');
fixType(BatchGetUnitRequest);
Builder.createAndAttachToType(BatchGetUnitRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 2942:3
 */
BatchGetUnitRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetUnitRequest.Constants').values;
/**
 * SOURCE BatchGetUnitResponse @ squareup/roster/mds.proto at 2956:1
 */
export const BatchGetUnitResponse = $root.lookupType('squareup.roster.mds.BatchGetUnitResponse');
fixType(BatchGetUnitResponse);
Builder.createAndAttachToType(BatchGetUnitResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 2957:3
 */
BatchGetUnitResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetUnitResponse.Entry');
fixType(BatchGetUnitResponse.Entry);
Builder.createAndAttachToType(BatchGetUnitResponse.Entry);
/**
 * SOURCE UpdateMerchantAppDataRequest @ squareup/roster/mds.proto at 2968:1
 */
export const UpdateMerchantAppDataRequest = $root.lookupType('squareup.roster.mds.UpdateMerchantAppDataRequest');
fixType(UpdateMerchantAppDataRequest);
Builder.createAndAttachToType(UpdateMerchantAppDataRequest);
/**
 * SOURCE UpdateMerchantAppDataResponse @ squareup/roster/mds.proto at 2986:1
 */
export const UpdateMerchantAppDataResponse = $root.lookupType('squareup.roster.mds.UpdateMerchantAppDataResponse');
fixType(UpdateMerchantAppDataResponse);
Builder.createAndAttachToType(UpdateMerchantAppDataResponse);
/**
 * SOURCE UpdateUnitAppDataRequest @ squareup/roster/mds.proto at 2991:1
 */
export const UpdateUnitAppDataRequest = $root.lookupType('squareup.roster.mds.UpdateUnitAppDataRequest');
fixType(UpdateUnitAppDataRequest);
Builder.createAndAttachToType(UpdateUnitAppDataRequest);
/**
 * SOURCE UpdateUnitAppDataResponse @ squareup/roster/mds.proto at 3009:1
 */
export const UpdateUnitAppDataResponse = $root.lookupType('squareup.roster.mds.UpdateUnitAppDataResponse');
fixType(UpdateUnitAppDataResponse);
Builder.createAndAttachToType(UpdateUnitAppDataResponse);
/**
 * SOURCE UpdateMerchantAddressesRequest @ squareup/roster/mds.proto at 3014:1
 */
export const UpdateMerchantAddressesRequest = $root.lookupType('squareup.roster.mds.UpdateMerchantAddressesRequest');
fixType(UpdateMerchantAddressesRequest);
Builder.createAndAttachToType(UpdateMerchantAddressesRequest);
/**
 * SOURCE UpdateMerchantAddressesResponse @ squareup/roster/mds.proto at 3024:1
 */
export const UpdateMerchantAddressesResponse = $root.lookupType('squareup.roster.mds.UpdateMerchantAddressesResponse');
fixType(UpdateMerchantAddressesResponse);
Builder.createAndAttachToType(UpdateMerchantAddressesResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 3028:3
 */
UpdateMerchantAddressesResponse.Error = $root.lookupEnum('squareup.roster.mds.UpdateMerchantAddressesResponse.Error').values;
/**
 * SOURCE UpdateMerchantCapabilitiesRequest @ squareup/roster/mds.proto at 3044:1
 */
export const UpdateMerchantCapabilitiesRequest = $root.lookupType('squareup.roster.mds.UpdateMerchantCapabilitiesRequest');
fixType(UpdateMerchantCapabilitiesRequest);
Builder.createAndAttachToType(UpdateMerchantCapabilitiesRequest);
/**
 * Capabilities that can be enabled and disabled for a Merchant. The request
 * capability names must match the corresponding MerchantCapabilities field names.
 *
 * SOURCE MerchantCapability @ squareup/roster/mds.proto at 3059:3
 */
UpdateMerchantCapabilitiesRequest.MerchantCapability = $root.lookupEnum('squareup.roster.mds.UpdateMerchantCapabilitiesRequest.MerchantCapability').values;
/**
 * SOURCE UpdateMerchantCapabilitiesResponse @ squareup/roster/mds.proto at 3126:1
 */
export const UpdateMerchantCapabilitiesResponse = $root.lookupType('squareup.roster.mds.UpdateMerchantCapabilitiesResponse');
fixType(UpdateMerchantCapabilitiesResponse);
Builder.createAndAttachToType(UpdateMerchantCapabilitiesResponse);
/**
 * SOURCE UpdateMerchantTwoFactorStateRequest @ squareup/roster/mds.proto at 3134:1
 */
export const UpdateMerchantTwoFactorStateRequest = $root.lookupType('squareup.roster.mds.UpdateMerchantTwoFactorStateRequest');
fixType(UpdateMerchantTwoFactorStateRequest);
Builder.createAndAttachToType(UpdateMerchantTwoFactorStateRequest);
/**
 * SOURCE UpdateMerchantTwoFactorStateResponse @ squareup/roster/mds.proto at 3145:1
 */
export const UpdateMerchantTwoFactorStateResponse = $root.lookupType('squareup.roster.mds.UpdateMerchantTwoFactorStateResponse');
fixType(UpdateMerchantTwoFactorStateResponse);
Builder.createAndAttachToType(UpdateMerchantTwoFactorStateResponse);
/**
 * SOURCE UpdateUnitCapabilitiesRequest @ squareup/roster/mds.proto at 3153:1
 */
export const UpdateUnitCapabilitiesRequest = $root.lookupType('squareup.roster.mds.UpdateUnitCapabilitiesRequest');
fixType(UpdateUnitCapabilitiesRequest);
Builder.createAndAttachToType(UpdateUnitCapabilitiesRequest);
/**
 * Capabilities that can be enabled and disabled for a Unit. The request
 * capability names must match the corresponding UnitCapabilities field names.
 *
 * SOURCE UnitCapability @ squareup/roster/mds.proto at 3168:3
 */
UpdateUnitCapabilitiesRequest.UnitCapability = $root.lookupEnum('squareup.roster.mds.UpdateUnitCapabilitiesRequest.UnitCapability').values;
/**
 * SOURCE UpdateUnitCapabilitiesResponse @ squareup/roster/mds.proto at 3200:1
 */
export const UpdateUnitCapabilitiesResponse = $root.lookupType('squareup.roster.mds.UpdateUnitCapabilitiesResponse');
fixType(UpdateUnitCapabilitiesResponse);
Builder.createAndAttachToType(UpdateUnitCapabilitiesResponse);
/**
 * SOURCE FindEmploymentsV2Request @ squareup/roster/mds.proto at 3208:1
 */
export const FindEmploymentsV2Request = $root.lookupType('squareup.roster.mds.FindEmploymentsV2Request');
fixType(FindEmploymentsV2Request, {
  employmentFilter: {
    required: true
  }
});
Builder.createAndAttachToType(FindEmploymentsV2Request);
/**
 * The filter for which employments should be found. Each supplied field within a single
 * EgEmploymentFilter will be AND'ed together to produce the final result.
 * Note: merchant_token must be provided
 *
 * SOURCE EgEmploymentFilter @ squareup/roster/mds.proto at 3225:1
 */
export const EgEmploymentFilter = $root.lookupType('squareup.roster.mds.EgEmploymentFilter');
fixType(EgEmploymentFilter, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(EgEmploymentFilter);
/**
 * Sorting order for employments
 *
 * SOURCE EgEmploymentSortOrder @ squareup/roster/mds.proto at 3267:1
 */
export const EgEmploymentSortOrder = $root.lookupEnum('squareup.roster.mds.EgEmploymentSortOrder').values;
/**
 * The filter for which employee roles should be found. Each supplied field within a single
 * EgEmployeeRoleFilter will be AND'ed together to produce the final result.
 *
 * SOURCE EgEmployeeRoleFilter @ squareup/roster/mds.proto at 3284:1
 */
export const EgEmployeeRoleFilter = $root.lookupType('squareup.roster.mds.EgEmployeeRoleFilter');
fixType(EgEmployeeRoleFilter);
Builder.createAndAttachToType(EgEmployeeRoleFilter);
/**
 * The filter for which locations should be found. Each supplied field within a single
 * EgLocationFilter will be AND'ed together to produce the final result.
 *
 * SOURCE EgLocationFilter @ squareup/roster/mds.proto at 3300:1
 */
export const EgLocationFilter = $root.lookupType('squareup.roster.mds.EgLocationFilter');
fixType(EgLocationFilter);
Builder.createAndAttachToType(EgLocationFilter);
/**
 * This entity contains the a subset of the information in an MDS employment that
 * represents what is stored in elasticgraph
 *
 * SOURCE EgEmployment @ squareup/roster/mds.proto at 3319:1
 */
export const EgEmployment = $root.lookupType('squareup.roster.mds.EgEmployment');
fixType(EgEmployment);
Builder.createAndAttachToType(EgEmployment);
/**
 * SOURCE FindEmploymentsV2Response @ squareup/roster/mds.proto at 3373:1
 */
export const FindEmploymentsV2Response = $root.lookupType('squareup.roster.mds.FindEmploymentsV2Response');
fixType(FindEmploymentsV2Response);
Builder.createAndAttachToType(FindEmploymentsV2Response);
/**
 * SOURCE FindEmploymentsRequest @ squareup/roster/mds.proto at 3382:1
 */
export const FindEmploymentsRequest = $root.lookupType('squareup.roster.mds.FindEmploymentsRequest');
fixType(FindEmploymentsRequest);
Builder.createAndAttachToType(FindEmploymentsRequest);
/**
 * SOURCE FindEmploymentTokensRequest @ squareup/roster/mds.proto at 3399:1
 */
export const FindEmploymentTokensRequest = $root.lookupType('squareup.roster.mds.FindEmploymentTokensRequest');
fixType(FindEmploymentTokensRequest);
Builder.createAndAttachToType(FindEmploymentTokensRequest);
/**
 * The query for which employments should be found. Each supplied field within a single
 * EmploymentQuery will be AND'ed together to produce the final result.
 *
 * Note: one of person_token, employee_role_token, or merchant_token
 * must at least be filled out. Multiple of these may be provided though.
 *
 * SOURCE EmploymentQuery @ squareup/roster/mds.proto at 3415:1
 */
export const EmploymentQuery = $root.lookupType('squareup.roster.mds.EmploymentQuery');
fixType(EmploymentQuery);
Builder.createAndAttachToType(EmploymentQuery);
/**
 * SOURCE FindEmploymentsResponse @ squareup/roster/mds.proto at 3464:1
 */
export const FindEmploymentsResponse = $root.lookupType('squareup.roster.mds.FindEmploymentsResponse');
fixType(FindEmploymentsResponse);
Builder.createAndAttachToType(FindEmploymentsResponse);
/**
 * SOURCE GetEmploymentRequest @ squareup/roster/mds.proto at 3473:1
 */
export const GetEmploymentRequest = $root.lookupType('squareup.roster.mds.GetEmploymentRequest');
fixType(GetEmploymentRequest);
Builder.createAndAttachToType(GetEmploymentRequest);
/**
 * SOURCE GetEmploymentResponse @ squareup/roster/mds.proto at 3484:1
 */
export const GetEmploymentResponse = $root.lookupType('squareup.roster.mds.GetEmploymentResponse');
fixType(GetEmploymentResponse);
Builder.createAndAttachToType(GetEmploymentResponse);
/**
 * SOURCE BatchGetEmploymentRequest @ squareup/roster/mds.proto at 3489:1
 */
export const BatchGetEmploymentRequest = $root.lookupType('squareup.roster.mds.BatchGetEmploymentRequest');
fixType(BatchGetEmploymentRequest);
Builder.createAndAttachToType(BatchGetEmploymentRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 3490:3
 */
BatchGetEmploymentRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetEmploymentRequest.Constants').values;
/**
 * SOURCE BatchGetEmploymentResponse @ squareup/roster/mds.proto at 3504:1
 */
export const BatchGetEmploymentResponse = $root.lookupType('squareup.roster.mds.BatchGetEmploymentResponse');
fixType(BatchGetEmploymentResponse);
Builder.createAndAttachToType(BatchGetEmploymentResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 3505:3
 */
BatchGetEmploymentResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetEmploymentResponse.Entry');
fixType(BatchGetEmploymentResponse.Entry);
Builder.createAndAttachToType(BatchGetEmploymentResponse.Entry);
/**
 * SOURCE GetNumberOfEmploymentsRequest @ squareup/roster/mds.proto at 3516:1
 */
export const GetNumberOfEmploymentsRequest = $root.lookupType('squareup.roster.mds.GetNumberOfEmploymentsRequest');
fixType(GetNumberOfEmploymentsRequest);
Builder.createAndAttachToType(GetNumberOfEmploymentsRequest);
/**
 * SOURCE GetNumberOfEmploymentsResponse @ squareup/roster/mds.proto at 3521:1
 */
export const GetNumberOfEmploymentsResponse = $root.lookupType('squareup.roster.mds.GetNumberOfEmploymentsResponse');
fixType(GetNumberOfEmploymentsResponse);
Builder.createAndAttachToType(GetNumberOfEmploymentsResponse);
/**
 * SOURCE GetEmploymentsForMerchantRequest @ squareup/roster/mds.proto at 3526:1
 */
export const GetEmploymentsForMerchantRequest = $root.lookupType('squareup.roster.mds.GetEmploymentsForMerchantRequest');
fixType(GetEmploymentsForMerchantRequest);
Builder.createAndAttachToType(GetEmploymentsForMerchantRequest);
/**
 * SOURCE GetEmploymentsForMerchantResponse @ squareup/roster/mds.proto at 3535:1
 */
export const GetEmploymentsForMerchantResponse = $root.lookupType('squareup.roster.mds.GetEmploymentsForMerchantResponse');
fixType(GetEmploymentsForMerchantResponse);
Builder.createAndAttachToType(GetEmploymentsForMerchantResponse);
/**
 * SOURCE GenerateEmploymentPasscodeRequest @ squareup/roster/mds.proto at 3542:1
 */
export const GenerateEmploymentPasscodeRequest = $root.lookupType('squareup.roster.mds.GenerateEmploymentPasscodeRequest');
fixType(GenerateEmploymentPasscodeRequest);
Builder.createAndAttachToType(GenerateEmploymentPasscodeRequest);
/**
 * SOURCE GenerateEmploymentPasscodeResponse @ squareup/roster/mds.proto at 3550:1
 */
export const GenerateEmploymentPasscodeResponse = $root.lookupType('squareup.roster.mds.GenerateEmploymentPasscodeResponse');
fixType(GenerateEmploymentPasscodeResponse);
Builder.createAndAttachToType(GenerateEmploymentPasscodeResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 3557:3
 */
GenerateEmploymentPasscodeResponse.Error = $root.lookupEnum('squareup.roster.mds.GenerateEmploymentPasscodeResponse.Error').values;
/**
 * SOURCE UpdateEmploymentPasscodeRequest @ squareup/roster/mds.proto at 3566:1
 */
export const UpdateEmploymentPasscodeRequest = $root.lookupType('squareup.roster.mds.UpdateEmploymentPasscodeRequest');
fixType(UpdateEmploymentPasscodeRequest);
Builder.createAndAttachToType(UpdateEmploymentPasscodeRequest);
/**
 * SOURCE UpdateEmploymentPasscodeResponse @ squareup/roster/mds.proto at 3586:1
 */
export const UpdateEmploymentPasscodeResponse = $root.lookupType('squareup.roster.mds.UpdateEmploymentPasscodeResponse');
fixType(UpdateEmploymentPasscodeResponse);
Builder.createAndAttachToType(UpdateEmploymentPasscodeResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 3587:3
 */
UpdateEmploymentPasscodeResponse.Error = $root.lookupEnum('squareup.roster.mds.UpdateEmploymentPasscodeResponse.Error').values;
/**
 * SOURCE ValidateEmploymentPasscodeRequest @ squareup/roster/mds.proto at 3605:1
 */
export const ValidateEmploymentPasscodeRequest = $root.lookupType('squareup.roster.mds.ValidateEmploymentPasscodeRequest');
fixType(ValidateEmploymentPasscodeRequest);
Builder.createAndAttachToType(ValidateEmploymentPasscodeRequest);
/**
 * SOURCE ValidateEmploymentPasscodeResponse @ squareup/roster/mds.proto at 3622:1
 */
export const ValidateEmploymentPasscodeResponse = $root.lookupType('squareup.roster.mds.ValidateEmploymentPasscodeResponse');
fixType(ValidateEmploymentPasscodeResponse);
Builder.createAndAttachToType(ValidateEmploymentPasscodeResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 3623:3
 */
ValidateEmploymentPasscodeResponse.Error = $root.lookupEnum('squareup.roster.mds.ValidateEmploymentPasscodeResponse.Error').values;
/**
 * SOURCE EmploymentForPos @ squareup/roster/mds.proto at 3638:1
 */
export const EmploymentForPos = $root.lookupType('squareup.roster.mds.EmploymentForPos');
fixType(EmploymentForPos);
Builder.createAndAttachToType(EmploymentForPos);
/**
 * SOURCE ListEmploymentsForPosRequest @ squareup/roster/mds.proto at 3664:1
 */
export const ListEmploymentsForPosRequest = $root.lookupType('squareup.roster.mds.ListEmploymentsForPosRequest');
fixType(ListEmploymentsForPosRequest);
Builder.createAndAttachToType(ListEmploymentsForPosRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 3665:3
 */
ListEmploymentsForPosRequest.Constants = $root.lookupEnum('squareup.roster.mds.ListEmploymentsForPosRequest.Constants').values;
/**
 * SOURCE ListEmploymentsForPosResponse @ squareup/roster/mds.proto at 3681:1
 */
export const ListEmploymentsForPosResponse = $root.lookupType('squareup.roster.mds.ListEmploymentsForPosResponse');
fixType(ListEmploymentsForPosResponse);
Builder.createAndAttachToType(ListEmploymentsForPosResponse);
/**
 * SOURCE UpdateEmploymentAppDataRequest @ squareup/roster/mds.proto at 3692:1
 */
export const UpdateEmploymentAppDataRequest = $root.lookupType('squareup.roster.mds.UpdateEmploymentAppDataRequest');
fixType(UpdateEmploymentAppDataRequest);
Builder.createAndAttachToType(UpdateEmploymentAppDataRequest);
/**
 * SOURCE UpdateEmploymentAppDataResponse @ squareup/roster/mds.proto at 3710:1
 */
export const UpdateEmploymentAppDataResponse = $root.lookupType('squareup.roster.mds.UpdateEmploymentAppDataResponse');
fixType(UpdateEmploymentAppDataResponse);
Builder.createAndAttachToType(UpdateEmploymentAppDataResponse);
/**
 * SOURCE ListPermissionsRequest @ squareup/roster/mds.proto at 3715:1
 */
export const ListPermissionsRequest = $root.lookupType('squareup.roster.mds.ListPermissionsRequest');
fixType(ListPermissionsRequest);
Builder.createAndAttachToType(ListPermissionsRequest);
/**
 * SOURCE ListPermissionsResponse @ squareup/roster/mds.proto at 3719:1
 */
export const ListPermissionsResponse = $root.lookupType('squareup.roster.mds.ListPermissionsResponse');
fixType(ListPermissionsResponse);
Builder.createAndAttachToType(ListPermissionsResponse);
/**
 * SOURCE LookupTokenTypeRequest @ squareup/roster/mds.proto at 3723:1
 */
export const LookupTokenTypeRequest = $root.lookupType('squareup.roster.mds.LookupTokenTypeRequest');
fixType(LookupTokenTypeRequest);
Builder.createAndAttachToType(LookupTokenTypeRequest);
/**
 * SOURCE LookupTokenTypeResponse @ squareup/roster/mds.proto at 3728:1
 */
export const LookupTokenTypeResponse = $root.lookupType('squareup.roster.mds.LookupTokenTypeResponse');
fixType(LookupTokenTypeResponse);
Builder.createAndAttachToType(LookupTokenTypeResponse);
/**
 * SOURCE BatchLookupTokenTypeRequest @ squareup/roster/mds.proto at 3743:1
 */
export const BatchLookupTokenTypeRequest = $root.lookupType('squareup.roster.mds.BatchLookupTokenTypeRequest');
fixType(BatchLookupTokenTypeRequest);
Builder.createAndAttachToType(BatchLookupTokenTypeRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 3744:3
 */
BatchLookupTokenTypeRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchLookupTokenTypeRequest.Constants').values;
/**
 * SOURCE BatchLookupTokenTypeResponse @ squareup/roster/mds.proto at 3752:1
 */
export const BatchLookupTokenTypeResponse = $root.lookupType('squareup.roster.mds.BatchLookupTokenTypeResponse');
fixType(BatchLookupTokenTypeResponse);
Builder.createAndAttachToType(BatchLookupTokenTypeResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 3753:3
 */
BatchLookupTokenTypeResponse.Entry = $root.lookupType('squareup.roster.mds.BatchLookupTokenTypeResponse.Entry');
fixType(BatchLookupTokenTypeResponse.Entry);
Builder.createAndAttachToType(BatchLookupTokenTypeResponse.Entry);
/**
 * SOURCE BatchGetTokenForIdRequest @ squareup/roster/mds.proto at 3765:1
 */
export const BatchGetTokenForIdRequest = $root.lookupType('squareup.roster.mds.BatchGetTokenForIdRequest');
fixType(BatchGetTokenForIdRequest);
Builder.createAndAttachToType(BatchGetTokenForIdRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 3766:3
 */
BatchGetTokenForIdRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetTokenForIdRequest.Constants').values;
/**
 * SOURCE BatchGetTokenForIdResponse @ squareup/roster/mds.proto at 3774:1
 */
export const BatchGetTokenForIdResponse = $root.lookupType('squareup.roster.mds.BatchGetTokenForIdResponse');
fixType(BatchGetTokenForIdResponse);
Builder.createAndAttachToType(BatchGetTokenForIdResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 3775:3
 */
BatchGetTokenForIdResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetTokenForIdResponse.Entry');
fixType(BatchGetTokenForIdResponse.Entry);
Builder.createAndAttachToType(BatchGetTokenForIdResponse.Entry);
/**
 * SOURCE FindEmployeeRolesRequest @ squareup/roster/mds.proto at 3791:1
 */
export const FindEmployeeRolesRequest = $root.lookupType('squareup.roster.mds.FindEmployeeRolesRequest');
fixType(FindEmployeeRolesRequest);
Builder.createAndAttachToType(FindEmployeeRolesRequest);
/**
 * SOURCE FindEmployeeRolesResponse @ squareup/roster/mds.proto at 3811:1
 */
export const FindEmployeeRolesResponse = $root.lookupType('squareup.roster.mds.FindEmployeeRolesResponse');
fixType(FindEmployeeRolesResponse);
Builder.createAndAttachToType(FindEmployeeRolesResponse);
/**
 * Creates a new merchant account (merchant, unit, owner employment, and employee roles).
 * If an email and password are provided for an existing account, the existing tokens will be returned.
 * If the email is in use, but the password is incorrect, an EMAIL_TOKEN_ERROR will be returned.
 *
 * SOURCE CreateMerchantRequest @ squareup/roster/mds.proto at 3818:1
 */
export const CreateMerchantRequest = $root.lookupType('squareup.roster.mds.CreateMerchantRequest');
fixType(CreateMerchantRequest);
Builder.createAndAttachToType(CreateMerchantRequest);
/**
 * The capabilities a merchant may have at creation.
 *
 * SOURCE MerchantCapability @ squareup/roster/mds.proto at 3870:3
 */
CreateMerchantRequest.MerchantCapability = $root.lookupEnum('squareup.roster.mds.CreateMerchantRequest.MerchantCapability').values;
/**
 * SOURCE CreateMerchantResponse @ squareup/roster/mds.proto at 3907:1
 */
export const CreateMerchantResponse = $root.lookupType('squareup.roster.mds.CreateMerchantResponse');
fixType(CreateMerchantResponse);
Builder.createAndAttachToType(CreateMerchantResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 3908:3
 */
CreateMerchantResponse.Error = $root.lookupEnum('squareup.roster.mds.CreateMerchantResponse.Error').values;
/**
 * SOURCE GetEmploymentsForPersonRequest @ squareup/roster/mds.proto at 3980:1
 */
export const GetEmploymentsForPersonRequest = $root.lookupType('squareup.roster.mds.GetEmploymentsForPersonRequest');
fixType(GetEmploymentsForPersonRequest);
Builder.createAndAttachToType(GetEmploymentsForPersonRequest);
/**
 * SOURCE GetEmploymentsForPersonResponse @ squareup/roster/mds.proto at 3996:1
 */
export const GetEmploymentsForPersonResponse = $root.lookupType('squareup.roster.mds.GetEmploymentsForPersonResponse');
fixType(GetEmploymentsForPersonResponse);
Builder.createAndAttachToType(GetEmploymentsForPersonResponse);
/**
 * SOURCE ChangeOwnerRequest @ squareup/roster/mds.proto at 4026:1
 */
export const ChangeOwnerRequest = $root.lookupType('squareup.roster.mds.ChangeOwnerRequest');
fixType(ChangeOwnerRequest);
Builder.createAndAttachToType(ChangeOwnerRequest);
/**
 * SOURCE ChangeOwnerResponse @ squareup/roster/mds.proto at 4055:1
 */
export const ChangeOwnerResponse = $root.lookupType('squareup.roster.mds.ChangeOwnerResponse');
fixType(ChangeOwnerResponse);
Builder.createAndAttachToType(ChangeOwnerResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4056:3
 */
ChangeOwnerResponse.Error = $root.lookupEnum('squareup.roster.mds.ChangeOwnerResponse.Error').values;
/**
 * SOURCE BatchGetOwnerPersonTokenRequest @ squareup/roster/mds.proto at 4073:1
 */
export const BatchGetOwnerPersonTokenRequest = $root.lookupType('squareup.roster.mds.BatchGetOwnerPersonTokenRequest');
fixType(BatchGetOwnerPersonTokenRequest);
Builder.createAndAttachToType(BatchGetOwnerPersonTokenRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 4074:3
 */
BatchGetOwnerPersonTokenRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetOwnerPersonTokenRequest.Constants').values;
/**
 * SOURCE BatchGetOwnerPersonTokenResponse @ squareup/roster/mds.proto at 4081:1
 */
export const BatchGetOwnerPersonTokenResponse = $root.lookupType('squareup.roster.mds.BatchGetOwnerPersonTokenResponse');
fixType(BatchGetOwnerPersonTokenResponse);
Builder.createAndAttachToType(BatchGetOwnerPersonTokenResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 4082:3
 */
BatchGetOwnerPersonTokenResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetOwnerPersonTokenResponse.Entry');
fixType(BatchGetOwnerPersonTokenResponse.Entry);
Builder.createAndAttachToType(BatchGetOwnerPersonTokenResponse.Entry);
/**
 * Performs a de/activation of card processing capabilities.
 *
 * SOURCE UpdateUnitPaymentsPermissionRequest @ squareup/roster/mds.proto at 4095:1
 */
export const UpdateUnitPaymentsPermissionRequest = $root.lookupType('squareup.roster.mds.UpdateUnitPaymentsPermissionRequest');
fixType(UpdateUnitPaymentsPermissionRequest, {
  unitToken: {
    notEmpty: true
  },
  acceptPaymentCards: {
    required: true
  },
  actorMerchantToken: {
    notEmpty: true
  },
  reason: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateUnitPaymentsPermissionRequest);
/**
 * SOURCE CompleteEmployeeSignupResponse @ squareup/roster/mds.proto at 4109:1
 */
export const CompleteEmployeeSignupResponse = $root.lookupType('squareup.roster.mds.CompleteEmployeeSignupResponse');
fixType(CompleteEmployeeSignupResponse);
Builder.createAndAttachToType(CompleteEmployeeSignupResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4110:3
 */
CompleteEmployeeSignupResponse.Error = $root.lookupEnum('squareup.roster.mds.CompleteEmployeeSignupResponse.Error').values;
/**
 * SOURCE CreateOrUpdateEmploymentResponse @ squareup/roster/mds.proto at 4123:1
 */
export const CreateOrUpdateEmploymentResponse = $root.lookupType('squareup.roster.mds.CreateOrUpdateEmploymentResponse');
fixType(CreateOrUpdateEmploymentResponse);
Builder.createAndAttachToType(CreateOrUpdateEmploymentResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4124:3
 */
CreateOrUpdateEmploymentResponse.Error = $root.lookupEnum('squareup.roster.mds.CreateOrUpdateEmploymentResponse.Error').values;
/**
 * SOURCE CreateEmploymentRequest @ squareup/roster/mds.proto at 4159:1
 */
export const CreateEmploymentRequest = $root.lookupType('squareup.roster.mds.CreateEmploymentRequest');
fixType(CreateEmploymentRequest);
Builder.createAndAttachToType(CreateEmploymentRequest);
/**
 * SOURCE UpdateEmploymentRequest @ squareup/roster/mds.proto at 4175:1
 */
export const UpdateEmploymentRequest = $root.lookupType('squareup.roster.mds.UpdateEmploymentRequest');
fixType(UpdateEmploymentRequest);
Builder.createAndAttachToType(UpdateEmploymentRequest);
/**
 * Payload to create or update a new employment
 *
 * SOURCE CreateOrUpdateEmploymentPayload @ squareup/roster/mds.proto at 4191:1
 */
export const CreateOrUpdateEmploymentPayload = $root.lookupType('squareup.roster.mds.CreateOrUpdateEmploymentPayload');
fixType(CreateOrUpdateEmploymentPayload);
Builder.createAndAttachToType(CreateOrUpdateEmploymentPayload);
/**
 * Fields that can be removed.
 *
 * SOURCE RemoveField @ squareup/roster/mds.proto at 4193:3
 */
CreateOrUpdateEmploymentPayload.RemoveField = $root.lookupEnum('squareup.roster.mds.CreateOrUpdateEmploymentPayload.RemoveField').values;
/**
 * SOURCE CreateEmploymentResponse @ squareup/roster/mds.proto at 4274:1
 */
export const CreateEmploymentResponse = $root.lookupType('squareup.roster.mds.CreateEmploymentResponse');
fixType(CreateEmploymentResponse);
Builder.createAndAttachToType(CreateEmploymentResponse);
/**
 * SOURCE UpdateEmploymentResponse @ squareup/roster/mds.proto at 4284:1
 */
export const UpdateEmploymentResponse = $root.lookupType('squareup.roster.mds.UpdateEmploymentResponse');
fixType(UpdateEmploymentResponse);
Builder.createAndAttachToType(UpdateEmploymentResponse);
/**
 * Payload to create or update an employee role
 *
 * SOURCE CreateOrUpdateEmployeeRolePayload @ squareup/roster/mds.proto at 4295:1
 */
export const CreateOrUpdateEmployeeRolePayload = $root.lookupType('squareup.roster.mds.CreateOrUpdateEmployeeRolePayload');
fixType(CreateOrUpdateEmployeeRolePayload);
Builder.createAndAttachToType(CreateOrUpdateEmployeeRolePayload);
/**
 * SOURCE ManagedRoles @ squareup/roster/mds.proto at 4307:2
 */
CreateOrUpdateEmployeeRolePayload.ManagedRoles = $root.lookupType('squareup.roster.mds.CreateOrUpdateEmployeeRolePayload.ManagedRoles');
fixType(CreateOrUpdateEmployeeRolePayload.ManagedRoles);
Builder.createAndAttachToType(CreateOrUpdateEmployeeRolePayload.ManagedRoles);
/**
 * SOURCE CreateEmployeeRoleRequest @ squareup/roster/mds.proto at 4326:1
 */
export const CreateEmployeeRoleRequest = $root.lookupType('squareup.roster.mds.CreateEmployeeRoleRequest');
fixType(CreateEmployeeRoleRequest);
Builder.createAndAttachToType(CreateEmployeeRoleRequest);
/**
 * SOURCE CreateEmployeeRoleResponse @ squareup/roster/mds.proto at 4337:1
 */
export const CreateEmployeeRoleResponse = $root.lookupType('squareup.roster.mds.CreateEmployeeRoleResponse');
fixType(CreateEmployeeRoleResponse);
Builder.createAndAttachToType(CreateEmployeeRoleResponse);
/**
 * SOURCE UpdateEmployeeRoleRequest @ squareup/roster/mds.proto at 4341:1
 */
export const UpdateEmployeeRoleRequest = $root.lookupType('squareup.roster.mds.UpdateEmployeeRoleRequest');
fixType(UpdateEmployeeRoleRequest);
Builder.createAndAttachToType(UpdateEmployeeRoleRequest);
/**
 * SOURCE UpdateEmployeeRoleResponse @ squareup/roster/mds.proto at 4352:1
 */
export const UpdateEmployeeRoleResponse = $root.lookupType('squareup.roster.mds.UpdateEmployeeRoleResponse');
fixType(UpdateEmployeeRoleResponse);
Builder.createAndAttachToType(UpdateEmployeeRoleResponse);
/**
 * SOURCE DeleteEmployeeRoleRequest @ squareup/roster/mds.proto at 4356:1
 */
export const DeleteEmployeeRoleRequest = $root.lookupType('squareup.roster.mds.DeleteEmployeeRoleRequest');
fixType(DeleteEmployeeRoleRequest);
Builder.createAndAttachToType(DeleteEmployeeRoleRequest);
/**
 * SOURCE CreateUnitResponse @ squareup/roster/mds.proto at 4367:1
 */
export const CreateUnitResponse = $root.lookupType('squareup.roster.mds.CreateUnitResponse');
fixType(CreateUnitResponse);
Builder.createAndAttachToType(CreateUnitResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4368:3
 */
CreateUnitResponse.Error = $root.lookupEnum('squareup.roster.mds.CreateUnitResponse.Error').values;
/**
 * SOURCE DeactivateMerchantResponse @ squareup/roster/mds.proto at 4410:1
 */
export const DeactivateMerchantResponse = $root.lookupType('squareup.roster.mds.DeactivateMerchantResponse');
fixType(DeactivateMerchantResponse);
Builder.createAndAttachToType(DeactivateMerchantResponse);
/**
 * SOURCE DeleteEmployeeRoleResponse @ squareup/roster/mds.proto at 4411:1
 */
export const DeleteEmployeeRoleResponse = $root.lookupType('squareup.roster.mds.DeleteEmployeeRoleResponse');
fixType(DeleteEmployeeRoleResponse);
Builder.createAndAttachToType(DeleteEmployeeRoleResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4412:3
 */
DeleteEmployeeRoleResponse.Error = $root.lookupEnum('squareup.roster.mds.DeleteEmployeeRoleResponse.Error').values;
/**
 * SOURCE MigrateMerchantToNativeStorageResponse @ squareup/roster/mds.proto at 4430:1
 */
export const MigrateMerchantToNativeStorageResponse = $root.lookupType('squareup.roster.mds.MigrateMerchantToNativeStorageResponse');
fixType(MigrateMerchantToNativeStorageResponse);
Builder.createAndAttachToType(MigrateMerchantToNativeStorageResponse);
/**
 * SOURCE MultiunitUpgradeResponse @ squareup/roster/mds.proto at 4431:1
 */
export const MultiunitUpgradeResponse = $root.lookupType('squareup.roster.mds.MultiunitUpgradeResponse');
fixType(MultiunitUpgradeResponse);
Builder.createAndAttachToType(MultiunitUpgradeResponse);
/**
 * SOURCE ReactivateMerchantResponse @ squareup/roster/mds.proto at 4432:1
 */
export const ReactivateMerchantResponse = $root.lookupType('squareup.roster.mds.ReactivateMerchantResponse');
fixType(ReactivateMerchantResponse);
Builder.createAndAttachToType(ReactivateMerchantResponse);
/**
 * SOURCE UpdateUserResponse @ squareup/roster/mds.proto at 4434:1
 */
export const UpdateUserResponse = $root.lookupType('squareup.roster.mds.UpdateUserResponse');
fixType(UpdateUserResponse);
Builder.createAndAttachToType(UpdateUserResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4435:3
 */
UpdateUserResponse.Error = $root.lookupEnum('squareup.roster.mds.UpdateUserResponse.Error').values;
/**
 * SOURCE UpdateUnitPaymentsPermissionResponse @ squareup/roster/mds.proto at 4499:1
 */
export const UpdateUnitPaymentsPermissionResponse = $root.lookupType('squareup.roster.mds.UpdateUnitPaymentsPermissionResponse');
fixType(UpdateUnitPaymentsPermissionResponse);
Builder.createAndAttachToType(UpdateUnitPaymentsPermissionResponse);
/**
 * Obtain an online store slug for a unit. Generate a new one if the unit does
 * not already have one.
 *
 * SOURCE ObtainUnitSlugRequest @ squareup/roster/mds.proto at 4503:1
 */
export const ObtainUnitSlugRequest = $root.lookupType('squareup.roster.mds.ObtainUnitSlugRequest');
fixType(ObtainUnitSlugRequest);
Builder.createAndAttachToType(ObtainUnitSlugRequest);
/**
 * SOURCE ObtainUnitSlugResponse @ squareup/roster/mds.proto at 4511:1
 */
export const ObtainUnitSlugResponse = $root.lookupType('squareup.roster.mds.ObtainUnitSlugResponse');
fixType(ObtainUnitSlugResponse);
Builder.createAndAttachToType(ObtainUnitSlugResponse);
/**
 * SOURCE BatchGetOwnerForMerchantRequest @ squareup/roster/mds.proto at 4517:1
 */
export const BatchGetOwnerForMerchantRequest = $root.lookupType('squareup.roster.mds.BatchGetOwnerForMerchantRequest');
fixType(BatchGetOwnerForMerchantRequest);
Builder.createAndAttachToType(BatchGetOwnerForMerchantRequest);
/**
 * SOURCE Constants @ squareup/roster/mds.proto at 4518:3
 */
BatchGetOwnerForMerchantRequest.Constants = $root.lookupEnum('squareup.roster.mds.BatchGetOwnerForMerchantRequest.Constants').values;
/**
 * SOURCE BatchGetOwnerForMerchantResponse @ squareup/roster/mds.proto at 4528:1
 */
export const BatchGetOwnerForMerchantResponse = $root.lookupType('squareup.roster.mds.BatchGetOwnerForMerchantResponse');
fixType(BatchGetOwnerForMerchantResponse);
Builder.createAndAttachToType(BatchGetOwnerForMerchantResponse);
/**
 * SOURCE Entry @ squareup/roster/mds.proto at 4529:3
 */
BatchGetOwnerForMerchantResponse.Entry = $root.lookupType('squareup.roster.mds.BatchGetOwnerForMerchantResponse.Entry');
fixType(BatchGetOwnerForMerchantResponse.Entry);
Builder.createAndAttachToType(BatchGetOwnerForMerchantResponse.Entry);
/**
 * Request for reordering already uploaded images with purpose POS_ADDITIONAL.
 *
 * SOURCE ReorderUnitPosAdditionalImagesRequest @ squareup/roster/mds.proto at 4539:1
 */
export const ReorderUnitPosAdditionalImagesRequest = $root.lookupType('squareup.roster.mds.ReorderUnitPosAdditionalImagesRequest');
fixType(ReorderUnitPosAdditionalImagesRequest, {
  unitToken: {
    required: true
  },
  contentDigestsInOrder: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ReorderUnitPosAdditionalImagesRequest);
/**
 * Response from reordering already uploaded images with purpose POS_ADDITIONAL.
 *
 * SOURCE ReorderUnitPosAdditionalImagesResponse @ squareup/roster/mds.proto at 4549:1
 */
export const ReorderUnitPosAdditionalImagesResponse = $root.lookupType('squareup.roster.mds.ReorderUnitPosAdditionalImagesResponse');
fixType(ReorderUnitPosAdditionalImagesResponse);
Builder.createAndAttachToType(ReorderUnitPosAdditionalImagesResponse);
/**
 * SOURCE GeocodeUnitRequest @ squareup/roster/mds.proto at 4555:1
 */
export const GeocodeUnitRequest = $root.lookupType('squareup.roster.mds.GeocodeUnitRequest');
fixType(GeocodeUnitRequest);
Builder.createAndAttachToType(GeocodeUnitRequest);
/**
 * SOURCE GeocodeUnitResponse @ squareup/roster/mds.proto at 4563:1
 */
export const GeocodeUnitResponse = $root.lookupType('squareup.roster.mds.GeocodeUnitResponse');
fixType(GeocodeUnitResponse);
Builder.createAndAttachToType(GeocodeUnitResponse);
/**
 * SOURCE Status @ squareup/roster/mds.proto at 4564:3
 */
GeocodeUnitResponse.Status = $root.lookupEnum('squareup.roster.mds.GeocodeUnitResponse.Status').values;
/**
 * SOURCE UpdateUnitBrandDataRequest @ squareup/roster/mds.proto at 4588:1
 */
export const UpdateUnitBrandDataRequest = $root.lookupType('squareup.roster.mds.UpdateUnitBrandDataRequest');
fixType(UpdateUnitBrandDataRequest);
Builder.createAndAttachToType(UpdateUnitBrandDataRequest);
/**
 * Fields that can be removed.
 *
 * SOURCE RemoveField @ squareup/roster/mds.proto at 4623:3
 */
UpdateUnitBrandDataRequest.RemoveField = $root.lookupEnum('squareup.roster.mds.UpdateUnitBrandDataRequest.RemoveField').values;
/**
 * SOURCE UpdateUnitBrandDataResponse @ squareup/roster/mds.proto at 4636:1
 */
export const UpdateUnitBrandDataResponse = $root.lookupType('squareup.roster.mds.UpdateUnitBrandDataResponse');
fixType(UpdateUnitBrandDataResponse);
Builder.createAndAttachToType(UpdateUnitBrandDataResponse);
/**
 * SOURCE Status @ squareup/roster/mds.proto at 4637:3
 */
UpdateUnitBrandDataResponse.Status = $root.lookupEnum('squareup.roster.mds.UpdateUnitBrandDataResponse.Status').values;
/**
 * SOURCE UpdateUnitRequest @ squareup/roster/mds.proto at 4665:1
 */
export const UpdateUnitRequest = $root.lookupType('squareup.roster.mds.UpdateUnitRequest');
fixType(UpdateUnitRequest, {
  unitToken: {
    notEmpty: true
  },
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateUnitRequest);
/**
 * SOURCE UpdateUnitResponse @ squareup/roster/mds.proto at 4684:1
 */
export const UpdateUnitResponse = $root.lookupType('squareup.roster.mds.UpdateUnitResponse');
fixType(UpdateUnitResponse);
Builder.createAndAttachToType(UpdateUnitResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4685:3
 */
UpdateUnitResponse.Error = $root.lookupEnum('squareup.roster.mds.UpdateUnitResponse.Error').values;
/**
 * SOURCE UpdateMerchantRequest @ squareup/roster/mds.proto at 4703:1
 */
export const UpdateMerchantRequest = $root.lookupType('squareup.roster.mds.UpdateMerchantRequest');
fixType(UpdateMerchantRequest, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateMerchantRequest);
/**
 * SOURCE UpdateMerchantResponse @ squareup/roster/mds.proto at 4711:1
 */
export const UpdateMerchantResponse = $root.lookupType('squareup.roster.mds.UpdateMerchantResponse');
fixType(UpdateMerchantResponse);
Builder.createAndAttachToType(UpdateMerchantResponse);
/**
 * SOURCE Error @ squareup/roster/mds.proto at 4712:3
 */
UpdateMerchantResponse.Error = $root.lookupEnum('squareup.roster.mds.UpdateMerchantResponse.Error').values;
/**
 * SOURCE MerchantDataService @ squareup/roster/mds.proto at 4727:1
 */
export const MerchantDataService = $root.lookupService('squareup.roster.mds.MerchantDataService');